/* ============================================================
   BROKEN HEARTS — THE RITE (brief v2)
   Fracture intro -> world -> collections -> meaning (ritual rows)
   -> wheel of six (+ NIHIL, the absence, at the centre) -> metal (ritual rows) -> form (ritual rows)
   -> EDITORIAL VERDICT (no checkout: one CTA per piece -> real PDP).
   Stones v2: SANGUINIS garnet · VIRIDIS emerald · NOX black spinel ·
   LACRIMA lab diamond · ABYSSUS sapphire · VESPER amethyst · NIHIL no stone.
   Deterministic engine (pickRelics v2, budget removed -> tier 0).
   Pure engine functions exported for Node tests.
   ============================================================ */
(function () {
  'use strict';

  /* ================================================================
     PURE ENGINE (testable in Node)
  ================================================================ */
  function hashStr(s) { var h = 0; for (var i = 0; i < s.length; i++) { h = (h * 31 + s.charCodeAt(i)) | 0; } return Math.abs(h); }
  function priceTier(p) { return p.price <= 150 ? 1 : (p.price <= 300 ? 2 : 3); }

  /* PLACEHOLDER MAPPING (until rite.* metafields exist): collection /
     themes / stone / vis / family / tagline / why are derived from real
     titles + tags and this authored family table. Collection rule
     (owner to confirm): red garnet -> Reminiscenza, all else -> Palinsesto. */
  var STONE_SUFFIX = { SANGUINIS: 'garnet', NOX: 'spinel', UMBRA: 'spinel', VIRIDIS: 'emerald', ABYSSUS: 'sapphire', VESPER: 'amethyst', LACRIMA: 'diamond', LUX: 'diamond' };
  var STONE_LINES = {
    garnet: 'The wound that won’t close.',
    spinel: 'What the dark refused to take.',
    emerald: 'What returned, changed.',
    sapphire: 'What the silence still holds.',
    amethyst: 'The hour everything turned.',
    diamond: 'The light that didn’t ask permission.'
  };

  var FAMILY_META = {
    'ANULUS':   { t: ['inizio', 'peso'], line: 'A circle that began before you.', why: 'You keep beginnings small and permanent.', vis: 'intimate' },
    'CAVUM':    { t: ['perdita', 'segreto'], line: 'The hollow stays.', why: 'You carry an emptiness you refuse to fill.', vis: 'intimate' },
    'CINERES':  { t: ['fuoco', 'perdita'], line: 'What the fire left.', why: 'You walked through it and kept the ash.', vis: 'both' },
    'CORONA':   { t: ['peso', 'inizio'], line: 'A small crown, worn low.', why: 'You rule quietly over what is yours.', vis: 'intimate' },
    'CORTEX':   { t: ['segreto', 'inizio'], line: 'The bark remembers the tree.', why: 'Your surface protects what is still growing.', vis: 'intimate' },
    'CRUCEM':   { t: ['preghiera', 'perdita'], line: 'A cross, carried not spoken.', why: 'Your faith is private and permanent.', vis: 'intimate' },
    'CRUX':     { t: ['preghiera', 'peso'], line: 'The weight of the cross, made small.', why: 'You carry belief like a scar, close to the skin.', vis: 'both' },
    'CUMULUS':  { t: ['peso', 'inizio'], line: 'Stones gathered, not scattered.', why: 'You collect what others drop.', vis: 'both' },
    'DEVOTIO':  { t: ['preghiera', 'perdita'], line: 'Devotion, set in metal.', why: 'You stay when staying costs.', vis: 'intimate' },
    'FAITH':    { t: ['preghiera', 'inizio'], line: 'Faith without ornament.', why: 'You believe plainly, and that is rare.', vis: 'intimate' },
    'FILUM':    { t: ['inizio', 'taglio'], line: 'The thread that held.', why: 'You are connected by lines no one sees.', vis: 'intimate' },
    'FISSURA':  { t: ['taglio', 'perdita'], line: 'The crack, worn at the wrist.', why: 'Your break is visible, and survived.', vis: 'statement' },
    'FLORIS':   { t: ['inizio', 'fuoco'], line: 'A flower that refused to wilt.', why: 'You keep something delicate alive in the dark.', vis: 'intimate' },
    'FORMA':    { t: ['inizio', 'segreto'], line: 'Form before meaning.', why: 'You trust shape more than words.', vis: 'statement' },
    'FOSSIL':   { t: ['inizio', 'perdita'], line: 'What was before, pressed into now.', why: 'You carry your past as structure, not weight.', vis: 'both' },
    'FRACTUM':  { t: ['taglio', 'peso'], line: 'Broken, and kept.', why: 'You don’t hide the break: you wear it.', vis: 'both' },
    'FRACTURA': { t: ['taglio', 'fuoco'], line: 'The fracture, filled with blood.', why: 'Your scars are set with something precious.', vis: 'statement' },
    'GOLGA':    { t: ['preghiera', 'perdita'], line: 'The hill of the skull, made small.', why: 'You have buried something and still visit it.', vis: 'both' },
    'HEART':    { t: ['perdita', 'fuoco'], line: 'A heart, broken on purpose.', why: 'You loved past the point of safety.', vis: 'both' },
    'INCISIO':  { t: ['taglio', 'segreto'], line: 'The incision heals open.', why: 'Some cuts you choose to keep.', vis: 'intimate' },
    'KLUSTER':  { t: ['fuoco', 'peso'], line: 'Embers, set close together.', why: 'What burns in you burns in clusters.', vis: 'both' },
    'LAPIS':    { t: ['peso', 'inizio'], line: 'The first stone.', why: 'You build from what others overlook.', vis: 'intimate' },
    'NEXUM':    { t: ['peso', 'preghiera'], line: 'The bond that holds.', why: 'Your ties are chosen, not inherited.', vis: 'intimate' },
    'NODUS':    { t: ['segreto', 'peso'], line: 'The knot no one unties.', why: 'You hold complications with grace.', vis: 'statement' },
    'ORBIS':    { t: ['inizio', 'preghiera'], line: 'The circle closes.', why: 'You finish what you begin, quietly.', vis: 'intimate' },
    'ORBITA':   { t: ['inizio', 'peso'], line: 'What orbits never leaves.', why: 'The people you keep stay kept.', vis: 'intimate' },
    'ORIGO':    { t: ['inizio', 'segreto'], line: 'Where it began.', why: 'You return to your origin without shame.', vis: 'intimate' },
    'PASSIO':   { t: ['preghiera', 'fuoco'], line: 'Passion, worn small.', why: 'What moves you does not need an audience.', vis: 'intimate' },
    'PATIBOLO': { t: ['peso', 'perdita'], line: 'The beam that bore the weight.', why: 'You have carried what should have broken you.', vis: 'statement' },
    'PLAGA':    { t: ['taglio', 'fuoco'], line: 'The blow landed. You stayed.', why: 'You answer damage with presence.', vis: 'both' },
    'PLEXUS':   { t: ['peso', 'preghiera'], line: 'Woven, not welded.', why: 'Your strength is made of many small holds.', vis: 'statement' },
    'PONDUS':   { t: ['peso', 'segreto'], line: 'Weight, worn willingly.', why: 'You chose your burden, and that changes it.', vis: 'intimate' },
    'QUADRA':   { t: ['peso', 'inizio'], line: 'Four corners, one center.', why: 'You keep order where others lose it.', vis: 'intimate' },
    'QUADRUM':  { t: ['peso', 'inizio'], line: 'The square does not roll.', why: 'You are the still point.', vis: 'intimate' },
    'RELIC':    { t: ['perdita', 'preghiera'], line: 'What remains is sacred.', why: 'You keep relics: of people, of versions of you.', vis: 'statement' },
    'RUINA':    { t: ['perdita', 'peso'], line: 'Ruins are still architecture.', why: 'What collapsed in you still stands as form.', vis: 'both' },
    'SAXUM':    { t: ['peso', 'fuoco'], line: 'The rock holds the wound.', why: 'You are the steady one, and it cost you.', vis: 'statement' },
    'SCISSUM':  { t: ['taglio', 'perdita'], line: 'The scar, cleaved and held together.', why: 'There is a before and an after in you, visibly.', vis: 'statement' },
    'SCUTUM':   { t: ['peso', 'segreto'], line: 'The shield keeps the stone.', why: 'You defend something you never show.', vis: 'statement' },
    'SIGILLUM': { t: ['segreto', 'preghiera'], line: 'Sealed, not silenced.', why: 'Your word is your seal.', vis: 'statement' },
    'SIGNUM':   { t: ['segreto', 'inizio'], line: 'A sign, not an explanation.', why: 'You mark what matters and move on.', vis: 'both' },
    'STIGMA':   { t: ['taglio', 'segreto'], line: 'The mark that stays.', why: 'You were marked by something, and made it yours.', vis: 'intimate' },
    'STRATUM':  { t: ['peso', 'segreto'], line: 'Layer upon layer.', why: 'Your depth is built, not given.', vis: 'statement' },
    'SULNA':    { t: ['inizio', 'segreto'], line: 'Small, and not minor.', why: 'You speak softly with permanent things.', vis: 'intimate' },
    'TACTUM':   { t: ['segreto', 'inizio'], line: 'Touch leaves marks.', why: 'You remember through the hands.', vis: 'intimate' },
    'TAXIO':    { t: ['segreto', 'inizio'], line: 'A quiet order.', why: 'Your discipline is invisible and total.', vis: 'intimate' },
    'TERNUM':   { t: ['preghiera', 'peso'], line: 'Three stones. One vow.', why: 'What you promise, you promise completely.', vis: 'statement' },
    'TORUS':    { t: ['peso', 'inizio'], line: 'The ring within the ring.', why: 'Your strength repeats itself.', vis: 'intimate' },
    'VINCULUM': { t: ['peso', 'segreto'], line: 'The chain you chose.', why: 'Your bonds are deliberate.', vis: 'intimate' },
    'VIRGULA':  { t: ['inizio', 'taglio'], line: 'A small stroke that changes the sentence.', why: 'Your details rewrite the whole.', vis: 'intimate' },
    'VOLUMEN':  { t: ['preghiera', 'segreto'], line: 'The scroll, rolled shut.', why: 'Your story is written and not shown.', vis: 'statement' },
    'VULNUS':   { t: ['taglio', 'perdita'], line: 'The wound, named.', why: 'You call things what they are, even the painful ones.', vis: 'both' },
    /* Rinomine 2026-07: le vecchie chiavi restano sopra per sicurezza durante la transizione.
       Per RADIX, TITULUS e COPULA la copy è riscritta: il significato del nome è cambiato. */
    'FIDES':     { t: ['preghiera', 'inizio'], line: 'Faith without ornament.', why: 'You believe plainly, and that is rare.', vis: 'intimate' },
    'IMPRESSIO': { t: ['inizio', 'perdita'], line: 'What was before, pressed into now.', why: 'You carry your past as structure, not weight.', vis: 'both' },
    'RELIQUIA':  { t: ['perdita', 'preghiera'], line: 'What remains is sacred.', why: 'You keep relics: of people, of versions of you.', vis: 'statement' },
    'PATIBULUM': { t: ['peso', 'perdita'], line: 'The beam that bore the weight.', why: 'You have carried what should have broken you.', vis: 'statement' },
    'TORQUES':   { t: ['inizio', 'segreto'], line: 'Small, and not minor.', why: 'You speak softly with permanent things.', vis: 'intimate' },
    'CRUCICULA': { t: ['preghiera', 'segreto'], line: 'The smallest cross still counts.', why: 'Your devotion does not ask for scale.', vis: 'intimate' },
    'RADIX':     { t: ['preghiera', 'perdita'], line: 'What holds is under the ground.', why: 'Your faith grew roots where no one was looking.', vis: 'intimate' },
    'FLOS':      { t: ['inizio', 'fuoco'], line: 'A flower that refused to wilt.', why: 'You keep something delicate alive in the dark.', vis: 'intimate' },
    'COPULA':    { t: ['inizio', 'preghiera'], line: 'Two circles, one hold.', why: 'What you bind, you do not drop.', vis: 'intimate' },
    'SPIRA':     { t: ['peso', 'inizio'], line: 'It wraps twice and stays.', why: 'You return to what matters, closer each time.', vis: 'intimate' },
    'CORCULUM':  { t: ['perdita', 'fuoco'], line: 'A heart, broken on purpose.', why: 'You loved past the point of safety.', vis: 'both' },
    'TITULUS':   { t: ['preghiera', 'perdita'], line: 'The name they nailed above it.', why: 'You keep the inscription, not the wound.', vis: 'both' },
    'RUPTUM':    { t: ['taglio', 'peso'], line: 'Broken, and kept.', why: 'You don’t hide the break: you wear it.', vis: 'both' }
  };
  var DEFAULT_META = { t: ['peso', 'inizio'], line: 'Forged when asked for.', why: 'You were recognized, not persuaded.', vis: 'both' };

  function mapProduct(raw) {
    if (!raw || !raw.variants || !raw.variants.length) return null;
    var T = raw.title.toUpperCase().trim();
    var tags = (raw.tags || []).map(function (s) { return String(s).toLowerCase(); });
    var has = function (t) { return tags.indexOf(t) > -1; };
    /* un pezzo requiem o sanctvm non e' una vendita rapida: fuori dal mazzo del rito qui,
       nell'unico punto in cui il catalogo client-side viene costruito dal fetch products.json */
    if (has('requiem') || has('sanctvm')) return null;
    var cat = has('anello') ? 'ring' : has('ciondolo') ? 'cross' : has('collana') ? 'neck' : has('orecchini') ? 'ear' : has('braccialetto') ? 'wrist' : null;
    if (!cat) return null;
    var words = T.replace(/^GOLDEN\s+/, '').split(/\s+/);
    var stone = null;
    var last = words[words.length - 1];
    if (STONE_SUFFIX[last]) { stone = STONE_SUFFIX[last]; words.pop(); }
    var family = words.join(' ');
    if (!stone) {
      if (has('garnet')) stone = 'garnet';
      else if (has('obsidian')) stone = 'spinel';
      else if (has('emerald')) stone = 'emerald';
      else if (has('lapis')) stone = 'sapphire';
      else if (has('amethyst')) stone = 'amethyst';
      else if (has('diamond')) stone = 'diamond';
      else if (has('senza-pietre')) stone = 'blank';
      else if (has('con-pietre')) stone = 'garnet';
      else stone = 'blank';
    }
    var prices = raw.variants.map(function (v) { return parseFloat(v.price); });
    var price = Math.min.apply(null, prices);
    var from = prices.some(function (x) { return x !== price; }) || raw.variants.length > 1;
    var meta = FAMILY_META[family] || DEFAULT_META;
    var line = (stone !== 'blank' && STONE_LINES[stone]) ? STONE_LINES[stone] : meta.line;
    /* collection = the REAL product tags (owner taxonomy); fallback by
       stone only for the few untagged families */
    var collection;
    if (has('reminiscenza')) collection = 'rem';
    else if (has('palinsesto')) collection = 'pal';
    else if (has('materia')) collection = 'mat';
    else collection = (stone === 'blank' || stone === 'none') ? 'pal' : 'rem';
    return {
      id: raw.handle,
      family: family,
      name: raw.title.toUpperCase(),
      line: line,
      why: meta.why,
      collection: collection,
      cat: cat,
      mat: has('golden') ? 'gold' : 'silver',
      themes: meta.t,
      stone: stone,
      vis: meta.vis,
      price: price,
      from: from,
      img: (raw.images && raw.images[0]) ? raw.images[0].src : '',
      imgs: (raw.images || []).map(function (im) { return im.src; })
    };
  }

  function buildCatalog(lists) {
    var seen = {}, out = [];
    for (var i = 0; i < lists.length; i++) {
      var arr = lists[i] || [];
      for (var j = 0; j < arr.length; j++) {
        var raw = arr[j];
        if (seen[raw.handle]) continue;
        seen[raw.handle] = 1;
        var p = mapProduct(raw);
        if (p) out.push(p);
      }
    }
    out.sort(function (a, b) { return a.id < b.id ? -1 : a.id > b.id ? 1 : 0; });
    return out;
  }

  /* engine — brief v2, verbatim shape + session exclusion:
     redoing the rite never repeats pieces already shown, until the
     cell is exhausted and the cycle restarts. Deterministic for the
     same (answers, drawn-history). */
  function stoneMatch(p, stone) {
    if (!stone || stone === 'any') return true;
    var st = p.stone || 'none';
    if (stone === 'blank') return st === 'blank' || st === 'none';
    return st === stone;
  }
  /* pieces available for a (collection, stone[, place]) cell — wheel gating + tests.
     `cat` is optional: when set (ring/cross/neck/ear/wrist) the count honors the
     declared PLACE, so a category surface never gates on a form it doesn't make. */
  function countCell(PRODUCTS, collection, stone, cat) {
    var n = 0;
    for (var i = 0; i < PRODUCTS.length; i++) {
      var p = PRODUCTS[i];
      if (collection !== 'any' && p.collection !== collection) continue;
      if (!stoneMatch(p, stone)) continue;
      if (cat && cat !== 'any' && p.cat !== cat) continue;
      n++;
    }
    return n;
  }

  /* pieces available for a (collection, stone, metal[, place]) cell */
  function countCellM(PRODUCTS, collection, stone, mat, cat) {
    var n = 0;
    for (var i = 0; i < PRODUCTS.length; i++) {
      var p = PRODUCTS[i];
      if (collection !== 'any' && p.collection !== collection) continue;
      if (!stoneMatch(p, stone)) continue;
      if (mat !== 'any' && p.mat !== mat) continue;
      if (cat && cat !== 'any' && p.cat !== cat) continue;
      n++;
    }
    return n;
  }

  /* == IL PENSIERO (owner 28-08-2026) ===================================
     Il rito era classificatorio: sceglievi da un menu e ti collocava in una
     casella. Nessuno scriveva niente di suo, quindi nessuno poteva sentirsi
     letto. Qui la persona scrive una frase e il rito la LEGGE.
     Non c'e' nessun modello: c'e' un lessico della casa, sette campi
     semantici, e la lettura avviene NEL BROWSER. Non esce niente, non c'e'
     attesa, non c'e' una chiave da nascondere, non fallisce mai, e il token
     condiviso resta deterministico. In cambio il rito fa la cosa che un
     modello non fa meglio: CITA le parole di chi ha scritto. */
  var THEME_STONE = { perdita: "garnet", taglio: "amethyst", peso: "sapphire", preghiera: "blank", fuoco: "spinel", segreto: "diamond", inizio: "emerald" };
  var LEX = {
    perdita: ["perd","perso","persa","mort","lutto","addio","manca","mancanz","vuot","assenz","portato via","portata via","andato via","andata via","se n'e andato","lost","loss","died","death","gone","miss","absence","empty","taken away"],
    taglio: ["prima","dopo","cambiat","spezz","rott","frattur","divis","separaz","divorzi","finit","before","after","broke","broken","split","changed","ended"],
    peso: ["peso","pesa","caric","fardell","colpa","responsabil","weight","carry","heavy","burden","guilt"],
    preghiera: ["non ho detto","parol","silenzi","tacer","scus","perdon","unsaid","words","silence","sorry","forgive","pray"],
    fuoco: ["rabbia","furia","bruciat","brucia","resistit","sopravviss","anger","rage","burn","burned","fire","survived"],
    segreto: ["segret","nessuno sa","nascost","vergogn","secret","nobody","hidden","shame","alone"],
    inizio: ["torn","ritorn","ricominc","nuov","rinasc","cresc","again","return","begin","start","grew"]
  };
  var LEX_STONE = {
    garnet: ["sangu","blood","ferit","wound"],
    spinel: ["nott","buio","nero","night","dark","black"],
    sapphire: ["mare","blu","fond","sea","blue","deep"],
    amethyst: ["sera","tramont","dusk","evening","hour"],
    emerald: ["verde","green","crescit","grow"],
    diamond: ["luce","lacrim","light","tear"],
    blank: ["il nulla","nothingness"]
  };
  function norm(t) {
    t = String(t || "").toLowerCase();
    try { return t.normalize("NFD").replace(/[\u0300-\u036f]/g, ""); } catch (e) { return t; }
  }
  /* la PAROLA VERA scritta dalla persona che contiene lo stem: il rito cita
     lei, non il proprio dizionario */
  function wordFor(raw, stem) {
    /* uno stem puo essere una locuzione ("portato via"): in quel caso si cita
       la prima delle sue parole che compare davvero nel testo, mai la locuzione
       del nostro dizionario */
    if (stem.indexOf(" ") > -1) {
      var parts = stem.split(" ");
      for (var q = 0; q < parts.length; q++) {
        var w = wordFor(raw, parts[q]);
        if (w) return w;
      }
      return null;
    }
    var words = String(raw).split(/[^A-Za-z\u00C0-\u024F\u2019']+/).filter(Boolean);
    for (var i = 0; i < words.length; i++) {
      if (norm(words[i]).indexOf(stem) > -1) return words[i];
    }
    return null;
  }
  function readThought(raw) {
    var t = norm(raw);
    if (!t || t.length < 3) return null;
    var best = null, bestScore = 0, k, i, sc;
    for (k in LEX) {
      sc = 0;
      for (i = 0; i < LEX[k].length; i++) if (t.indexOf(LEX[k][i]) > -1) sc += LEX[k][i].length;
      if (sc > bestScore) { bestScore = sc; best = k; }
    }
    if (!best) return null;
    var longest = null;
    for (i = 0; i < LEX[best].length; i++) {
      if (t.indexOf(LEX[best][i]) > -1 && (!longest || LEX[best][i].length > longest.length)) longest = LEX[best][i];
    }
    var stone = THEME_STONE[best] || null;
    var hit = null;
    for (k in LEX_STONE) {
      if (hit) break;
      for (i = 0; i < LEX_STONE[k].length; i++) if (t.indexOf(LEX_STONE[k][i]) > -1) { hit = k; break; }
    }
    if (hit) stone = hit;
    return { theme: best, stone: stone, word: (longest ? wordFor(raw, longest) : null) };
  }

  function pickRelics(PRODUCTS, a, exclude) {
    exclude = exclude || [];

    function scoreSet(set) {
      return set.map(function (p) {
        var s = 0;
        if (p.themes[0] === a.theme) s += 36; else if (p.themes.indexOf(a.theme) > -1) s += 20;
        if (a.tier === 0) { s += Math.min(p.price, 460) * 0.03; }
        else {
          var d = priceTier(p) - a.tier;
          if (d === 0) s += 16; else if (d === -1) s += 6; else if (d === -2) s += 2; else if (d === 1) s -= 14; else s -= 46;
        }
        if (a.collection === 'any' && p.collection === 'rem') s += 3;
        if (a.cat === 'any' && p.cat === 'ring') s += 5;
        s += (hashStr(p.id + a.theme + (a.stone || '')) % 7) * 0.07;
        return { p: p, s: s };
      }).sort(function (x, y) { return y.s - x.s || x.p.id.localeCompare(y.p.id); });
    }

    /* collection, stone and METAL relax before the PLACE. When the visitor has
       DECLARED a category (entered from /rings, /pendants, /necklaces, ...), the
       form is SACRED — a pendants page never answers with a ring. Only concept
       entries (cat 'any') may relax the form. The stone is always absolute. */
    var mat = a.mat;
    var catSet = (a.cat && a.cat !== 'any');
    function cellPool(withCat) {
      return PRODUCTS.filter(function (p) {
        if (a.collection !== 'any' && p.collection !== a.collection) return false;
        if (!stoneMatch(p, a.stone)) return false;
        if (mat !== 'any' && p.mat !== mat) return false;
        if (withCat && a.cat !== 'any' && p.cat !== a.cat) return false;
        return true;
      });
    }
    var pool = cellPool(true);
    if (pool.length < 3 && !catSet) pool = cellPool(false);

    var scored = scoreSet(pool);
    if (!scored.length) return { top: null, alts: [], bridge: false };

    if (mat === 'any') {
      /* the rite locks the house metal: the metal of the best piece */
      mat = scored[0].p.mat;
      pool = cellPool(true);
      if (pool.length < 3 && !catSet) pool = cellPool(false);
      scored = scoreSet(pool);
    }

    var want = Math.min(3, scored.length);
    var avail = scored.filter(function (c2) { return exclude.indexOf(c2.p.id) === -1; });
    if (avail.length < want) avail = scored;

    var top = avail[0].p;
    var alts = []; var fams = {}; fams[top.family] = 1;
    var c, i, k;
    for (i = 1; i < avail.length; i++) {
      c = avail[i]; if (alts.length >= want - 1) break;
      if (!fams[c.p.family]) { alts.push(c.p); fams[c.p.family] = 1; }
    }
    /* family diversity beats form fidelity: complete from the SAME
       collection+stone+metal cell in other forms before ever repeating
       a design */
    if (alts.length < want - 1) {
      /* keep the PLACE when it was declared — fill the trio from the same
         category in other houses/metals before ever crossing form */
      var wide = scoreSet(cellPool(catSet));
      var wideAvail = wide.filter(function (c3) { return exclude.indexOf(c3.p.id) === -1; });
      if (wideAvail.length < want) wideAvail = wide;
      for (i = 0; i < wideAvail.length; i++) {
        c = wideAvail[i]; if (alts.length >= want - 1) break;
        if (c.p !== top && !fams[c.p.family]) { alts.push(c.p); fams[c.p.family] = 1; }
      }
    }
    for (k = 1; k < avail.length; k++) {
      c = avail[k]; if (alts.length >= want - 1) break;
      if (alts.indexOf(c.p) === -1 && c.p !== top) alts.push(c.p);
    }

    /* -- LA SCALA DEL TRIO (owner 28-08-2026) ----------------------------
       Il rito deve rispondere con TRE. Prima di questa scala, chi entrava
       da una pagina di categoria restava spesso con UN pezzo solo: la forma
       e' dichiarata sacra, quindi cellPool(catSet) non allargava niente, e
       se quella cella aveva meno di tre pezzi il trio non si completava.
       Qui il TOP non si tocca: e' scelto esattamente come prima. Si
       allentano solo i due compagni, nell'ordine che costa meno dottrina.
       LA PIETRA NON SI ALLENTA MAI, a nessun livello: e' l'unica cosa che
       il rito ha davvero letto nel visitatore.
         livello 1  cade il metallo
         livello 2  cade la casa (collezione)
         livello 3  cade la forma, e solo qui, come ultima cosa
       A ogni livello si preferisce una famiglia non ancora vista, cosi' il
       trio non mostra mai due volte lo stesso disegno. */
    if (alts.length < 2) {
      var rungs = [
        function (q) { return (a.collection === 'any' || q.collection === a.collection) && (!catSet || q.cat === a.cat); },
        function (q) { return (!catSet || q.cat === a.cat); },
        function (q) { return true; }
      ];
      for (var r = 0; r < rungs.length && alts.length < 2; r++) {
        var rung = scoreSet(PRODUCTS.filter(function (q) {
          if (!stoneMatch(q, a.stone)) return false;
          return rungs[r](q);
        }));
        var fresh = rung.filter(function (c4) { return exclude.indexOf(c4.p.id) === -1; });
        if (fresh.length < 3) fresh = rung;
        for (var pass = 0; pass < 2 && alts.length < 2; pass++) {
          for (i = 0; i < fresh.length; i++) {
            if (alts.length >= 2) break;
            c = fresh[i];
            if (c.p === top || alts.indexOf(c.p) > -1) continue;
            if (pass === 0 && fams[c.p.family]) continue;
            alts.push(c.p); fams[c.p.family] = 1;
          }
        }
      }
    }

    return { top: top, alts: alts, bridge: top.themes.indexOf(a.theme) === -1 };
  }

  if (typeof window === 'undefined') {
    module.exports = { hashStr: hashStr, priceTier: priceTier, mapProduct: mapProduct, buildCatalog: buildCatalog, pickRelics: pickRelics, readThought: readThought, countCell: countCell, countCellM: countCellM, FAMILY_META: FAMILY_META };
    return;
  }

  /* ================================================================
     BROWSER
  ================================================================ */
  if (window.__bhRiteInit) return;
  window.__bhRiteInit = true;

  var cfgEl = document.querySelector('[data-bh-rite-config]');
  if (!cfgEl) return;
  var CFG; try { CFG = JSON.parse(cfgEl.textContent); } catch (e) { return; }
  var ROOT = CFG.root || '/';
  var CONTACT_URL = 'mailto:support@brokenhearts.co'; /* PLACEHOLDER CONTACT_URL (Custode) */
  var REDUCED = false;
  try { REDUCED = window.matchMedia('(prefers-reduced-motion: reduce)').matches; } catch (e) {}
  var LOW_POWER = false;
  try { LOW_POWER = (navigator.hardwareConcurrency && navigator.hardwareConcurrency <= 4) || (navigator.deviceMemory && navigator.deviceMemory <= 4); } catch (e) {}

  /* ---------------- copy (EN, house voice) ---------------- */
  var COPY = {
    s0: [
      'We break the metal on purpose. Then we set a stone in the wound.',
      'You don’t pick a piece here. You are recognized by one.'
    ],
    s0cta: 'ENTER THE RITE',
    s0skip: 'Skip to the rite <span class=\"rite__arr\">&rarr;</span>',
    s0resume: 'Continue your rite <span class=\"rite__arr\">&rarr;</span>',
    s1: [
      'The fracture is the signature. The stone is the memory we set inside it.',
      'Sterling silver 925, or solid 18kt gold. Naples. Three to seven working days.'
    ],
    s1cta: 'CONTINUE',
    s2title: 'THREE WAYS OF REMEMBERING',
    s2decide: 'Let the rite decide <span class=\"rite__arr\">&rarr;</span>',
    s2hint: 'Each collection exists for a reason. The rite stays inside the one you choose.',
    collections: {
      rem: { name: 'Reminiscenza', line: 'Memory, set in stone.', desc: 'Made to keep what is gone: relics, signs, weights to carry. Stones set in the fractures.' },
      pal: { name: 'Palinsesto', line: 'The surface, rewritten.', desc: 'Made from surfaces that lived: engraved, scratched, rewritten metal. Marks, not stones.' },
      mat: { name: 'Materia', line: 'The raw form.', desc: 'Made before meaning: raw matter and first shapes, where every piece begins.' }
    },
    s3title: 'WHAT DO YOU CARRY?',
    themes: [
      { k: 'perdita', en: 'Something missing' },
      { k: 'taglio', en: 'A before and an after' },
      { k: 'peso', en: 'Something held' },
      { k: 'preghiera', en: 'Words no longer spoken' },
      { k: 'fuoco', en: 'What didn’t burn' },
      { k: 'segreto', en: 'What no one knows' },
      { k: 'inizio', en: 'What came before' }
    ],
    s4title: 'DRAW YOUR STONE',
    s4hint: 'The wheel holds six. One is yours.',
    thought: {
      ask: 'Or write it, in your own words.',
      place: 'Write the thing you have not said.',
      send: 'Let the rite read it',
      read: 'You wrote',
      toward: 'The rite turns toward',
      none: 'The rite found no word it knows in that. Choose a line above.'
    },
    s4take: 'THIS ONE',
    s4return: 'Return the card <span class=\"rite__arr\">&rarr;</span>',
    /* v2 stone corrections: NOX = black spinel · ABYSSUS = sapphire · VII = NIHIL */
    stones: [
      { k: 'garnet', num: 'I', name: 'SANGUINIS', sub: 'garnet', line: 'The wound that won’t close.', dot: '#9c1f1f', art: 'https://cdn.shopify.com/s/files/1/0787/8983/7088/files/SANGUINIS.png?v=1781190314' },
      { k: 'emerald', num: 'II', name: 'VIRIDIS', sub: 'emerald', line: 'What returned, changed.', dot: '#1B5E20', art: 'https://cdn.shopify.com/s/files/1/0787/8983/7088/files/VIRIDIS.png?v=1781190314' },
      { k: 'spinel', num: 'III', name: 'NOX', sub: 'black spinel', line: 'What the dark refused to take.', dot: '#101010', art: 'https://cdn.shopify.com/s/files/1/0787/8983/7088/files/NOX.png?v=1781190313' },
      { k: 'diamond', num: 'IV', name: 'LACRIMA', sub: 'lab diamond', line: 'The light that didn’t ask permission.', dot: '#E8E8E8', art: 'https://cdn.shopify.com/s/files/1/0787/8983/7088/files/lux.png?v=1781190301' },
      { k: 'sapphire', num: 'V', name: 'ABYSSUS', sub: 'sapphire', line: 'What the silence still holds.', dot: '#0D2C6E', art: 'https://cdn.shopify.com/s/files/1/0787/8983/7088/files/ABYSSUS.png?v=1781190314' },
      { k: 'amethyst', num: 'VI', name: 'VESPER', sub: 'amethyst', line: 'The hour everything turned.', dot: '#9575CD', art: 'https://cdn.shopify.com/s/files/1/0787/8983/7088/files/VESPER.png?v=1781190314' },
      { k: 'blank', num: 'VII', name: 'NIHIL', sub: 'no stone', line: 'No stone. The fracture left open — the rarest answer.', dot: null, art: 'https://cdn.shopify.com/s/files/1/0787/8983/7088/files/nihil.png?v=1781190301' }
    ],
    s45title: 'THE METAL',
    s45decide: 'Let the rite decide <span class=\"rite__arr\">&rarr;</span>',
    metals: [
      { k: 'silver', label: 'Silver 925', line: 'Cold, lunar light.' },
      { k: 'gold', label: 'Gold 18kt', line: 'Warm, solar weight.' }
    ],
    s5title: 'IN WHICH FORM WILL IT BE CARRIED?',
    s5decide: 'Let the fracture decide <span class=\"rite__arr\">&rarr;</span>',
    forms: { ring: 'Ring', cross: 'Pendant', ear: 'Earring', neck: 'Necklace', wrist: 'Bracelet' },
    formLines: {
      ring: 'The vow, worn and never spoken.',
      cross: 'The weight, on the chest.',
      neck: 'What circles the throat, stays.',
      wrist: 'At the wrist, what held you.',
      ear: 'The whisper, at the ear.'
    },
    /* one voice, valid whether it is kept or given */
    themeOpen: {
      perdita: 'An absence was named. The rite answers with a weight that can be touched.',
      taglio: 'There is a before and an after. This piece holds the line between them.',
      peso: 'What is held has mass. Now it has a form.',
      preghiera: 'Some words are no longer spoken. They can still be worn.',
      fuoco: 'What didn’t burn deserves to be kept. This is for what survived.',
      segreto: 'No one knows. The piece won’t tell either.',
      inizio: 'What came before is not gone. It set — like metal.'
    },
    matLine: {
      silver: 'Sterling silver 925, fractured by hand in Naples.',
      gold: 'Solid 18kt gold. Forged in Naples.'
    },
    visLine: { statement: 'Made to be seen first.', intimate: 'Made to be found late.', both: 'Worn loud, or kept close.' },
    bridge: 'The rite does not deliver what is asked. It delivers what recognizes.',
    verdict: {
      head: 'THE RITE',
      maison: 'The house recommends these three.',
      free: 'None of the three has to be taken. The rite answers; it does not sell.',
      three: 'Three pieces answered.',
      two: 'Two pieces answered.',
      one: 'One piece answered.',
      oneVein: 'The house keeps one in this vein.',
      choose: 'One of them is yours — choose the one that holds you. The reading follows.',
      ranks: [
        'Of the three, the rite names this one first.',
        'The rite would not let this one go.',
        'The third answer — quieter, not lesser.'
      ],
      others: 'The other two',
      otherOne: 'The other one',
      allThree: '<span class=\"rite__arr rite__arr--l\">&larr;</span> All three',
      allOf: '<span class=\"rite__arr rite__arr--l\">&larr;</span> All of them',
      see: 'SEE THE PIECE',
      facts: 'Forged to order in Naples &mdash; 3&ndash;7 working days. Lifetime guarantee. Free resizing.',
      redo: 'Redo the rite', custode: 'Talk to the Custode',
      reopen: 'REOPEN THE RITE',
      foot: 'Broken Hearts — Memory remains.',
      from: 'From '
    },
    keep: {
      cta: 'Keep your reading — have it sent to you<span class=\"rite__arr\">&rarr;</span>',
      ph: 'Your email',
      send: 'SEND',
      done: 'Sent. The reading is yours.'
    },
    aria: { rite: 'The Rite', close: 'Close' },
    facts: 'MADE TO ORDER, NAPLES &middot; 3&ndash;7 WORKING DAYS &middot; STERLING SILVER 925 &middot; LIFETIME GUARANTEE &middot; FREE RESIZING',
    /* reading fragments — templated ({name}/{sub} = drawn stone, {cname}/{csub} = piece's stone). Brand names stay fixed. */
    read: {
      drewSameNihil: 'NIHIL was drawn. Nothing distracts from the fracture — the metal answers alone.',
      drewSame: '{name} was drawn. It is here — {sub}, set in the wound.',
      drewAbsence: '{name} was drawn; this piece answers with absence. The metal alone.',
      drewBridge: '{name} was drawn; the draw lives in the reading. The piece that answered carries {cname} — {csub}, set in the wound.',
      matSilverAsked: 'Silver 925 — cold, lunar, as asked.',
      matGoldAsked: 'Solid 18kt gold — warm, solar, as asked.'
    },
    /* the shareable result page (/pages/rite?r=TOKEN) */
    result: {
      recognized: 'You were recognized by',
      reclaim: 'RECLAIM WHAT’S YOURS',
      share: 'Share your reading',
      copy: 'Copy this link',
      copied: 'Link copied',
      send: 'Send me my reading',
      take: 'Take the rite yourself',
      takeSub: 'No one chooses here. You are recognized by a piece.',
      three: 'The three that answered',
      rotate: 'Drag to turn',
      drawn: 'Your stone',
      story: 'Share to story'
    }
  };

  /* ---------------- localized copy overlay ----------------
     bh-rite-i18n.liquid injects the storefront-locale strings (rite.* keys);
     the English COPY above is the fallback. The brand lexicon — SANGUINIS,
     NOX, ABYSSUS, VESPER, VIRIDIS, LUX, NIHIL, FRACTURA, ALTRA LUCE — is
     never translated (stone .name / collection .name stay fixed in COPY and
     the shell carries translate="no"). A missing/partial locale degrades to
     English per-key, never to a broken "translation missing" string. */
  COPY = (function (base) {
    var cEl = document.querySelector('[data-bh-rite-copy]');
    if (!cEl) return base;
    var T; try { T = JSON.parse(cEl.textContent); } catch (e) { return base; }
    /* Shopify's `| t` HTML-escapes apostrophes/quotes (' -> &#39;, " -> &quot;). Many Rite
       strings are injected via textContent, so the raw entity would show ("what didn&#39;t
       burn"). Decode those two families once, over the whole locale overlay — fixes every
       language at the source. Left untouched on purpose: &rarr;/&larr; and any <span> markup
       appended in bh-rite-i18n.liquid (they must stay literal for the innerHTML CTAs), and
       &lt;/&gt; (so the existing <br> handling keeps working). */
    var deEnt = function (s) {
      return (typeof s === 'string' && s.indexOf('&') !== -1)
        ? s.replace(/&#0*39;/g, "'").replace(/&#x0*27;/gi, "'").replace(/&apos;/g, "'")
            .replace(/&quot;/g, '"').replace(/&#0*34;/g, '"')
        : s;
    };
    var deEntDeep = function (o) {
      if (typeof o === 'string') return deEnt(o);
      if (Array.isArray(o)) { for (var i = 0; i < o.length; i++) o[i] = deEntDeep(o[i]); return o; }
      if (o && typeof o === 'object') { for (var k in o) o[k] = deEntDeep(o[k]); return o; }
      return o;
    };
    T = deEntDeep(T);
    function bad(v) { return typeof v === 'string' && (!v || /ranslation missing/i.test(v)); }
    function merge(b, o) {
      if (o == null) return b;
      if (Array.isArray(b)) {
        if (!Array.isArray(o)) return b;
        var r = b.slice();
        for (var i = 0; i < r.length; i++) if (o[i] != null) r[i] = merge(r[i], o[i]);
        return r;
      }
      if (b && typeof b === 'object') {
        var out = {}; for (var k in b) out[k] = b[k];
        if (o && typeof o === 'object') for (var k2 in o) out[k2] = merge(b[k2], o[k2]);
        return out;
      }
      return bad(o) ? b : o;
    }
    return merge(base, T);
  })(COPY);

  /* ---------------- state ---------------- */
  var S = { step: 0, a: { collection: 'any', theme: null, stone: 'any', mat: 'any', cat: 'any', tier: 0 }, preset: { collection: false, cat: false }, open: false, savedScroll: 0, surface: '' };
  var PRODUCTS = null, catalogPromise = null;
  function savedRite() {
    try {
      var raw = sessionStorage.getItem('bh_rite_state');
      if (!raw) return null;
      var sv = JSON.parse(raw);
      return (sv && sv.step >= 2 && sv.step < 7 && sv.a) ? sv : null;
    } catch (e) { return null; }
  }
  var shell = null, emberRAF = 0, wheelCleanup = null, fractureCleanup = null;

  /* ---------------- utils ---------------- */
  /* -- IL SENSORE (owner 28-08-2026) -----------------------------------
     Il rito emetteva sedici eventi in window.dataLayer e NESSUNO li
     ascoltava: niente GTM, niente gtag, nessun consumatore nel tema. Per
     due anni il rito e' stato cieco, quindi ogni giudizio su di lui era
     un'opinione. Ora gli stessi eventi vengono pubblicati anche su
     Shopify Customer Events, che e' nativo, di prima parte, senza chiavi
     e senza dipendenze: da li' l'admin puo' instradarli dove vuole con un
     custom pixel. dataLayer resta per non rompere nulla. */
  function track(ev, data) {
    var p = { event: ev };
    for (var k in (data || {})) p[k] = data[k];
    try {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push(p);
    } catch (e) {}
    try {
      if (window.Shopify && window.Shopify.analytics && window.Shopify.analytics.publish) {
        window.Shopify.analytics.publish(ev, data || {});
      }
    } catch (e2) {}
  }
  function money(val) {
    var amt = Math.round(val * 100) / 100;
    var str = (amt % 1 === 0) ? String(amt) : amt.toFixed(2).replace('.', ',');
    var f = CFG.moneyFormat || '€{{ amount }}';
    return f.replace(/\{\{\s*amount[a-z_]*\s*\}\}/i, str).replace(/<[^>]+>/g, '');
  }
  function el(tag, cls, html) { var n = document.createElement(tag); if (cls) n.className = cls; if (html !== undefined) n.innerHTML = html; return n; }
  function imgUrl(src, w) {
    if (!src) return '';
    if (src.indexOf('//') === 0) src = 'https:' + src;
    return src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=' + w;
  }
  function esc(s) { return String(s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/"/g, '&quot;'); }
  function productUrl(p) { return ROOT + 'products/' + p.id; }

  /* ================================================================
     SHAREABLE RITE — the mapping is deterministic, so the answers ARE
     the record. A 5-char token encodes {collection, theme, stone, metal,
     form}; /pages/rite?r=TOKEN re-runs the same engine (empty DRAWN) and
     renders the same reading. No backend, no database.
  ================================================================ */
  var RITE_DIM = {
    collection: ['any', 'rem', 'pal', 'mat'],
    theme: ['', 'perdita', 'taglio', 'peso', 'preghiera', 'fuoco', 'segreto', 'inizio'],
    stone: ['any', 'garnet', 'emerald', 'spinel', 'diamond', 'sapphire', 'amethyst', 'blank'],
    mat: ['any', 'silver', 'gold'],
    cat: ['any', 'ring', 'cross', 'ear', 'neck', 'wrist']
  };
  var RITE_ORDER = ['collection', 'theme', 'stone', 'mat', 'cat'];
  var RITE_ALPHA = '0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ';
  function encodeRite(a) {
    var out = '';
    for (var i = 0; i < RITE_ORDER.length; i++) {
      var dim = RITE_ORDER[i], val = a[dim];
      if (dim === 'theme' && val == null) val = '';
      var idx = RITE_DIM[dim].indexOf(val);
      out += RITE_ALPHA.charAt(idx < 0 ? 0 : idx);
    }
    return out;
  }
  function decodeRite(tok) {
    if (!tok || tok.length < RITE_ORDER.length) return null;
    var a = { tier: 0, vis: 'any' };
    for (var i = 0; i < RITE_ORDER.length; i++) {
      var dim = RITE_ORDER[i], arr = RITE_DIM[dim], idx = RITE_ALPHA.indexOf(tok.charAt(i));
      if (idx < 0 || idx >= arr.length) return null;
      a[dim] = arr[idx];
    }
    a.theme = a.theme || null;
    return a;
  }
  function riteShareUrl(a) { return location.origin + ROOT + 'pages/rite?r=' + encodeRite(a); }
  /* RECLAIM carries the rite context to the PDP (consumed by the product page) */
  function reclaimUrl(p) {
    return productUrl(p) + '?rite=' + encodeRite(S.a) +
      '&rite_stone=' + encodeURIComponent(S.a.stone || '') +
      '&rite_metal=' + encodeURIComponent(p.mat || '') +
      '&rite_form=' + encodeURIComponent(p.cat || '');
  }

  /* Share + email-capture, reusable across the modal reading and the
     shared result page. */
  function bindShare(root) {
    var b = root.querySelector('.rite__v-sharebtn');
    if (!b) return;
    var orig = b.innerHTML;
    b.addEventListener('click', function () {
      var url = riteShareUrl(S.a);
      var title = (verdictR && verdictR.pieces && verdictR.pieces[0]) ? verdictR.pieces[0].name : 'BROKEN HEARTS';
      if (navigator.share) {
        navigator.share({ title: 'BROKEN HEARTS', text: title, url: url }).then(function () { track('rite_share', { method: 'native' }); }).catch(function () {});
      } else if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(url).then(function () {
          b.textContent = COPY.result.copied; track('rite_share', { method: 'copy' });
          setTimeout(function () { b.innerHTML = orig; }, 1800);
        }).catch(function () { try { window.prompt(COPY.result.copy, url); } catch (e) {} });
      } else { try { window.prompt(COPY.result.copy, url); } catch (e) {} }
    });
  }
  function bindKeep(root, p, src) {
    var keep = root.querySelector('.rite__v-keep');
    if (!keep) return;
    var keepBtn = keep.querySelector('.rite__v-keepbtn');
    var keepRow = keep.querySelector('.rite__v-keeprow');
    var sendBtn = keep.querySelector('.rite__v-keepsend');
    if (!keepBtn || !keepRow || !sendBtn) return;
    keepBtn.addEventListener('click', function () {
      keepBtn.hidden = true; keepRow.hidden = false;
      try { keepRow.querySelector('input').focus(); } catch (e) {}
    });
    sendBtn.addEventListener('click', function () {
      var inp = keepRow.querySelector('input');
      var em = (inp.value || '').trim();
      if (!em || em.indexOf('@') < 1) { inp.focus(); return; }
      var btn = this; btn.disabled = true;
      fetch('https://a.klaviyo.com/client/subscriptions/?company_id=SYAmQc', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', revision: '2024-10-15' },
        body: JSON.stringify({ data: { type: 'subscription', attributes: {
          custom_source: src || 'The Rite - reading',
          profile: { data: { type: 'profile', attributes: { email: em, properties: {
            rite_stone: S.a.stone || '', rite_theme: S.a.theme || '', rite_metal: p.mat || '',
            rite_collection: p.collection || '', rite_piece: p.id || ''
          } } } }
        }, relationships: { list: { data: { type: 'list', id: 'SC4ki7' } } } } })
      }).then(function () {
        keep.innerHTML = '<p class="rite__v-keepdone">' + COPY.keep.done + '</p>';
        track('rite_email_saved', { piece: p.id, source: src || 'reading' });
      }).catch(function () { btn.disabled = false; });
    });
  }

  /* ================================================================
     SHARE-CARD — the vertical story artifact (1080×1920), drawn on a
     canvas in the visitor's locale: brand mark, the drawn stone card,
     piece name, the sigil (stone · metal · form), one reading line, and
     the shareable link. One tap to post (Web Share files) or download.
  ================================================================ */
  function loadImg(src) {
    return new Promise(function (res, rej) {
      var im = new Image(); im.crossOrigin = 'anonymous';
      im.onload = function () { res(im); }; im.onerror = rej; im.src = src;
    });
  }
  function drawSpaced(ctx, text, cx, y, sp) {
    var prev = ctx.textAlign; ctx.textAlign = 'left';
    var widths = [], total = 0, i;
    for (i = 0; i < text.length; i++) { var w = ctx.measureText(text[i]).width; widths.push(w); total += w; }
    total += sp * (text.length - 1);
    var x = cx - total / 2;
    for (i = 0; i < text.length; i++) { ctx.fillText(text[i], x, y); x += widths[i] + sp; }
    ctx.textAlign = prev;
  }
  function wrapCenter(ctx, text, cx, y, maxW, lh) {
    var words = String(text).split(/\s+/), line = '', lines = [], i;
    for (i = 0; i < words.length; i++) {
      var t = line ? line + ' ' + words[i] : words[i];
      if (ctx.measureText(t).width > maxW && line) { lines.push(line); line = words[i]; } else line = t;
    }
    if (line) lines.push(line);
    for (i = 0; i < lines.length; i++) ctx.fillText(lines[i], cx, y + i * lh);
    return y + lines.length * lh;
  }
  function shareCard(p) {
    var drew = (S.a.stone && S.a.stone !== 'any') ? stoneCard(S.a.stone) : stoneCard(p.stone);
    var W = 1080, H = 1920, cv = document.createElement('canvas');
    cv.width = W; cv.height = H;
    var c = cv.getContext('2d');
    var serif = '"Cormorant Garamond", Georgia, serif';
    var fonts = (document.fonts && document.fonts.load)
      ? Promise.all([document.fonts.load('400 28px "Cormorant Garamond"'), document.fonts.load('600 76px "Cormorant Garamond"'), document.fonts.load('italic 40px "Cormorant Garamond"')]).catch(function () {})
      : Promise.resolve();
    var art = drew ? loadImg(imgUrl(drew.art, 900)).catch(function () { return null; }) : Promise.resolve(null);
    return Promise.all([art, fonts]).then(function (arr) {
      var cardImg = arr[0];
      c.fillStyle = '#0c0a09'; c.fillRect(0, 0, W, H);
      var g = c.createRadialGradient(W / 2, H * 0.40, 80, W / 2, H * 0.40, 780);
      g.addColorStop(0, 'rgba(156,31,31,0.20)'); g.addColorStop(1, 'rgba(12,10,9,0)');
      c.fillStyle = g; c.fillRect(0, 0, W, H);
      c.strokeStyle = 'rgba(233,225,210,0.14)'; c.lineWidth = 1; c.strokeRect(40, 40, W - 80, H - 80);
      c.textAlign = 'center';
      c.font = '28px ' + serif; c.fillStyle = 'rgba(233,225,210,0.8)';
      drawSpaced(c, 'BROKEN HEARTS', W / 2, 150, 10);
      c.strokeStyle = 'rgba(233,225,210,0.25)'; c.beginPath(); c.moveTo(W / 2 - 64, 184); c.lineTo(W / 2 + 64, 184); c.stroke();
      var cw = 540, ch = cw * 1.5, cx = (W - cw) / 2, cy = 250;
      if (cardImg) { c.save(); c.shadowColor = 'rgba(0,0,0,0.6)'; c.shadowBlur = 64; c.shadowOffsetY = 30; c.drawImage(cardImg, cx, cy, cw, ch); c.restore(); }
      var ty = cy + ch + 96;
      c.fillStyle = '#e9e1d2'; c.font = '600 76px ' + serif;
      ty = wrapCenter(c, p.name, W / 2, ty, W - 200, 84);
      var pst = stoneCard(p.stone);
      var sig = [pst ? pst.name : null, p.mat === 'gold' ? 'GOLD 18KT' : 'SILVER 925', (COPY.forms[p.cat] || '').toUpperCase()].filter(Boolean).join('   ·   ');
      c.font = '26px ' + serif; c.fillStyle = 'rgba(233,225,210,0.6)';
      drawSpaced(c, sig, W / 2, ty + 26, 5); ty += 88;
      c.font = 'italic 40px ' + serif; c.fillStyle = 'rgba(233,225,210,0.85)';
      ty = wrapCenter(c, p.why || p.line || '', W / 2, ty + 18, W - 240, 52);
      c.font = '24px ' + serif; c.fillStyle = 'rgba(233,225,210,0.5)';
      var host = location.host.replace(/^www\./, '');
      drawSpaced(c, COPY.result.take.toUpperCase() + '   ·   ' + host, W / 2, H - 120, 4);
      return cv;
    });
  }
  /* shareUrl facoltativo: la Veglia condivide la PROPRIA lettura, che il
     token a cinque caratteri non sa rappresentare (non porta ne il vis ne la
     parola scritta). Chi non lo passa resta al link di prima. */
  function shareStory(p, btn, shareUrl) {
    var orig = btn ? btn.innerHTML : '';
    if (btn) { btn.disabled = true; }
    shareCard(p).then(function (cv) {
      cv.toBlob(function (blob) {
        if (btn) { btn.disabled = false; }
        if (!blob) return;
        var file = null;
        try { file = new File([blob], 'the-rite.png', { type: 'image/png' }); } catch (e) {}
        var url = shareUrl || riteShareUrl(S.a);
        if (file && navigator.canShare && navigator.canShare({ files: [file] })) {
          navigator.share({ files: [file], title: 'BROKEN HEARTS', text: p.name, url: url })
            .then(function () { track('rite_share', { method: 'story' }); }).catch(function () {});
        } else {
          var a = document.createElement('a'); a.href = URL.createObjectURL(blob); a.download = 'the-rite.png';
          document.body.appendChild(a); a.click(); document.body.removeChild(a);
          setTimeout(function () { try { URL.revokeObjectURL(a.href); } catch (e) {} }, 2000);
          track('rite_share', { method: 'download' });
        }
      }, 'image/png');
    }).catch(function () { if (btn) { btn.disabled = false; btn.innerHTML = orig; } });
  }
  function bindStory(root, p) {
    var b = root.querySelector('.rite__v-storybtn');
    if (b) b.addEventListener('click', function () { shareStory(p, b); });
  }

  /* ================================================================
     RESULT PAGE (/pages/rite) — renders into #bh-rite-result.
     A shared link opens the recipient's reading; a first visit gets a
     clear "take the rite yourself" entry.
  ================================================================ */
  function mountStage(stage, p) {
    var frames = (p.imgs && p.imgs.length) ? p.imgs : (p.img ? [p.img] : []);
    var img = stage.querySelector('.rite-result__frame');
    if (!img || !frames.length) return;
    img.src = imgUrl(frames[0], 1100);
    var multi = frames.length > 1;
    if (multi) for (var f = 1; f < frames.length; f++) { var pre = new Image(); pre.src = imgUrl(frames[f], 1100); }
    if (!multi && frames.length <= 1) { /* single image: drag still tilts (affordance wired) */ }
    var idx = 0, dragging = false, startX = 0, startIdx = 0;
    function setFrame(i) { i = ((i % frames.length) + frames.length) % frames.length; if (i === idx) return; idx = i; img.src = imgUrl(frames[idx], 1100); }
    function px(e) { return e.touches ? e.touches[0].clientX : e.clientX; }
    function down(e) { dragging = true; startX = px(e); startIdx = idx; stage.classList.add('is-dragging'); document.addEventListener('mousemove', move); document.addEventListener('mouseup', up); }
    function move(e) {
      if (!dragging) return;
      var dx = px(e) - startX;
      if (multi) { setFrame(startIdx - Math.round(dx / 24)); }
      else { var t = Math.max(-14, Math.min(14, dx * 0.08)); img.style.transform = 'perspective(900px) rotateY(' + t + 'deg)'; }
    }
    function up() {
      if (!dragging) return; dragging = false; stage.classList.remove('is-dragging');
      document.removeEventListener('mousemove', move); document.removeEventListener('mouseup', up);
      if (!multi) { img.style.transition = 'transform .5s var(--ease)'; img.style.transform = 'perspective(900px) rotateY(0deg)'; setTimeout(function () { img.style.transition = ''; }, 520); }
    }
    stage.addEventListener('mousedown', down);
    stage.addEventListener('touchstart', down, { passive: true });
    stage.addEventListener('touchmove', move, { passive: true });
    stage.addEventListener('touchend', up);
  }

  function renderResultEntry(mount) {
    mount.innerHTML =
      '<div class="rite-result__entry">' +
        '<p class="rite-result__eyebrow">' + COPY.verdict.head + '</p>' +
        '<p class="rite-result__entry-line">' + COPY.result.takeSub + '</p>' +
        '<button type="button" class="rite__btn js-bhr-open" data-surface="result">' + COPY.result.take + '</button>' +
      '</div>';
  }

  function renderResult(mount, idx) {
    var pieces = verdictR.pieces, p = pieces[idx];
    var lines = buildReading(p, idx);
    var drew = (S.a.stone && S.a.stone !== 'any') ? stoneCard(S.a.stone) : stoneCard(p.stone);
    var pst = stoneCard(p.stone);
    var meta = (pst ? pst.name + ' · ' : '') + (p.from ? COPY.verdict.from : '') + money(p.price);
    var trio = pieces.map(function (op, i) {
      return '<button type="button" class="rite-result__trio-item' + (i === idx ? ' is-on' : '') + '" data-i="' + i + '">' +
        '<span class="rite-result__trio-img">' + (op.img ? '<img src="' + imgUrl(op.img, 320) + '" alt="' + esc(op.name) + '" loading="lazy">' : '') + '</span>' +
        '<span class="rite-result__trio-name">' + esc(op.name) + '</span>' +
      '</button>';
    }).join('');
    mount.innerHTML =
      '<div class="rite-result__inner">' +
        '<div class="rite-result__stage" aria-label="' + esc(p.name) + '">' +
          '<div class="rite-result__framewrap"><img class="rite-result__frame" alt="' + esc(p.name) + '" width="1100" height="1100" draggable="false"></div>' +
          '<span class="rite-result__rotate" aria-hidden="true">' + COPY.result.rotate + '</span>' +
          (drew ? '<span class="rite-result__drawn"><img src="' + imgUrl(drew.art, 320) + '" alt="' + esc(drew.name) + '"><em>' + esc(COPY.result.drawn) + '</em></span>' : '') +
        '</div>' +
        '<div class="rite-result__col">' +
          '<p class="rite-result__eyebrow">' + COPY.result.recognized + '</p>' +
          '<h1 class="rite-result__name"><a href="' + reclaimUrl(p) + '" data-reclaim>' + esc(p.name) + '</a></h1>' +
          '<p class="rite-result__meta">' + meta + '</p>' +
          '<div class="rite-result__reading">' + lines.map(function (s, i) { return '<p style="--i:' + i + '">' + s + '</p>'; }).join('') + '</div>' +
          '<p class="rite-result__why">' + p.why + '</p>' +
          '<a class="rite__btn rite__btn--solid rite-result__reclaim" href="' + reclaimUrl(p) + '" data-reclaim>' + COPY.result.reclaim + '<span class="rite__arr">&rarr;</span></a>' +
          '<div class="rite-result__actions"><button type="button" class="rite__ghost rite__v-sharebtn">' + COPY.result.share + '</button><button type="button" class="rite__ghost rite__v-storybtn">' + COPY.result.story + '</button></div>' +
          '<div class="rite-result__keep rite__v-keep">' +
            '<button type="button" class="rite__ghost rite__v-keepbtn">' + COPY.result.send + '<span class="rite__arr">&rarr;</span></button>' +
            '<div class="rite__v-keeprow" hidden>' +
              '<input type="email" placeholder="' + esc(COPY.keep.ph) + '" autocomplete="email">' +
              '<button type="button" class="rite__v-keepsend">' + COPY.keep.send + '</button>' +
            '</div>' +
          '</div>' +
          '<p class="rite-result__facts">' + COPY.verdict.facts + '</p>' +
        '</div>' +
        (pieces.length > 1 ?
          '<div class="rite-result__trio">' +
            '<p class="rite-result__trio-h">' + COPY.result.three + '</p>' +
            '<div class="rite-result__trio-row">' + trio + '</div>' +
          '</div>' : '') +
      '</div>';
    mountStage(mount.querySelector('.rite-result__stage'), p);
    bindShare(mount);
    bindStory(mount, p);
    bindKeep(mount, p, 'The Rite - shared reading');
    var rec = mount.querySelectorAll('[data-reclaim]');
    for (var ri = 0; ri < rec.length; ri++) rec[ri].addEventListener('click', function () { try { sessionStorage.setItem('bh_rite_done', '1'); } catch (e) {} track('rite_reclaim', { handle: p.id }); });
    var tb = mount.querySelectorAll('.rite-result__trio-item');
    for (var ti = 0; ti < tb.length; ti++) tb[ti].addEventListener('click', function () {
      var o = parseInt(this.getAttribute('data-i'), 10);
      if (o === idx) return;
      track('select_item', { handle: pieces[o].id, position: o });
      renderResult(mount, o);
      try { window.scrollTo({ top: mount.getBoundingClientRect().top + window.pageYOffset - 24, behavior: REDUCED ? 'auto' : 'smooth' }); } catch (e) {}
    });
  }

  function initResultPage() {
    var mount = document.getElementById('bh-rite-result');
    if (!mount) return;
    var tok = null;
    try { tok = new URLSearchParams(location.search).get('r'); } catch (e) {}
    var a = tok ? decodeRite(tok) : null;
    if (!a) { renderResultEntry(mount); return; }
    S.a = { collection: a.collection, theme: a.theme, stone: a.stone, mat: a.mat, cat: a.cat, tier: 0 };
    S.surface = 'result';
    mount.innerHTML = '<div class="rite__forging"><span class="rite__loader"></span></div>';
    loadCatalog().then(function () {
      var r = pickRelics(PRODUCTS, S.a, []);
      if (!r || !r.top) { renderResultEntry(mount); return; }
      verdictR = { pieces: [r.top].concat(r.alts), bridge: r.bridge };
      track('rite_result_view', { top: r.top.id, token: tok });
      renderResult(mount, 0);
    });
  }

  /* ---------------- catalog ---------------- */
  function loadCatalog() {
    if (catalogPromise) return catalogPromise;
    /* the rite draws from the WHOLE house (every published piece),
       including the bh-family-variant colored siblings that the curated
       collection grids hide — the rite is the only surface where every
       family lives in all six stones. */
    catalogPromise = fetch(ROOT + 'products.json?limit=250')
      .then(function (r) { return r.ok ? r.json() : { products: [] }; })
      .then(function (d) {
        PRODUCTS = buildCatalog([d.products || []]);
        return PRODUCTS;
      })
      .catch(function () { PRODUCTS = []; return PRODUCTS; });
    return catalogPromise;
  }
  function poolForms(collection) {
    var forms = [];
    for (var i = 0; i < PRODUCTS.length; i++) {
      var p = PRODUCTS[i];
      if (collection !== 'any' && p.collection !== collection) continue;
      if (forms.indexOf(p.cat) === -1) forms.push(p.cat);
    }
    var order = ['ring', 'cross', 'ear', 'neck', 'wrist'];
    forms.sort(function (a, b) { return order.indexOf(a) - order.indexOf(b); });
    return forms;
  }
  function collectionImage(key) {
    /* Dedicated editorial imagery for the houses (owner 2026-06-11): the landing-page photos
       used for materia / palinsesto, instead of placeholder ring product shots. */
    var ART = {
      mat: 'https://cdn.shopify.com/s/files/1/0787/8983/7088/files/hf_20260519_234902_1_d27ef930-30d7-4136-8609-a6632a91815f.png?v=1779237045',
      pal: 'https://cdn.shopify.com/s/files/1/0787/8983/7088/files/hf_20260519_215310_4beb5f79-2875-40a3-bdd8-deda90e56820.png?v=1779227786',
      rem: 'https://cdn.shopify.com/s/files/1/0787/8983/7088/files/hf_20260522_151438_81eb8a86-ff66-4ecc-b2e4-39ed6e8ef436.png?v=1779463079'
    };
    if (ART[key]) return ART[key];
    /* PLACEHOLDER fallback: a real product photo stands in until dedicated imagery exists. */
    var want = { rem: ['reliquia-sanguinis', 'relic-sanguinis'], pal: ['lapis'], mat: ['kluster-sanguinis'] }[key] || [];
    for (var w = 0; w < want.length; w++) {
      for (var i = 0; i < PRODUCTS.length; i++) if (PRODUCTS[i].id === want[w]) return PRODUCTS[i].img;
    }
    for (var j = 0; j < PRODUCTS.length; j++) if (PRODUCTS[j].collection === key && PRODUCTS[j].img) return PRODUCTS[j].img;
    return '';
  }
  function preloadCards() {
    for (var i = 0; i < COPY.stones.length; i++) {
      var im = new Image();
      im.src = imgUrl(COPY.stones[i].art, 720);
    }
  }

  /* ---------------- shell + atmosphere ---------------- */
  var GRAIN = 'data:image/svg+xml;utf8,' + encodeURIComponent('<svg xmlns="http://www.w3.org/2000/svg" width="160" height="160"><filter id="n"><feTurbulence type="fractalNoise" baseFrequency="0.9" numOctaves="2"/></filter><rect width="160" height="160" filter="url(#n)" opacity="0.55"/></svg>');

  function buildShell() {
    if (shell) return shell;
    shell = el('div', 'rite');
    shell.setAttribute('role', 'dialog');
    shell.setAttribute('aria-modal', 'true');
    shell.setAttribute('aria-label', COPY.aria.rite);
    shell.setAttribute('translate', 'no');
    try { shell.setAttribute('lang', document.documentElement.getAttribute('lang') || CFG.locale || 'en'); } catch (e) {}
    shell.innerHTML =
      '<div class="rite__fog" aria-hidden="true"></div>' +
      '<canvas class="rite__embers" aria-hidden="true"></canvas>' +
      '<div class="rite__grain" aria-hidden="true" style="background-image:url(\'' + GRAIN + '\')"></div>' +
      '<div class="rite__vignette" aria-hidden="true"></div>' +
      '<div class="rite__head">' +
        '<div class="rite__steps" aria-hidden="true"></div>' +
        '<button type="button" class="rite__close" aria-label="' + esc(COPY.aria.close) + '"><svg width="15" height="15" viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="1"><line x1="1" y1="1" x2="15" y2="15"/><line x1="15" y1="1" x2="1" y2="15"/></svg></button>' +
      '</div>' +
      '<div class="rite__stage" aria-live="polite"></div>' +
      /* la fascia dei fatti (FATTO SU ORDINAZIONE, NAPOLI, ARGENTO STERLING,
         GARANZIA A VITA, MODIFICA MISURA GRATUITA) non viene piu' renderizzata:
         owner 28-08-2026. Cavalcava OGNI schermata del rito dopo la soglia ed
         era un trust badge, cioe' una delle cose che il marchio non fa. La copy
         e le chiavi locale restano al loro posto, non renderizzate: rimetterla
         e' una riga, e non abbiamo toccato quindici lingue per toglierla. */
      '<div class="rite__cursor" aria-hidden="true"></div>';
    document.body.appendChild(shell);

    shell.querySelector('.rite__close').addEventListener('click', function () { closeRite(true); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && S.open) closeRite(true); });

    if (!REDUCED && window.matchMedia('(hover: hover)').matches) {
      var dot = shell.querySelector('.rite__cursor');
      var mx = -100, my = -100, cx = -100, cy = -100;
      shell.addEventListener('mousemove', function (e) { mx = e.clientX; my = e.clientY; });
      (function loop() {
        if (!S.open) return;
        requestAnimationFrame(loop);
        var dx = mx - cx, dy = my - cy;
        if (dx * dx + dy * dy < 0.05) return; /* pointer still: no work */
        cx += dx * 0.16; cy += dy * 0.16;
        dot.style.transform = 'translate(' + cx + 'px,' + cy + 'px)';
      })();
    }
    return shell;
  }

  function startEmbers() {
    if (REDUCED) return;
    var cv = shell.querySelector('.rite__embers');
    var ctx = cv.getContext('2d');
    var W, H, parts = [];
    var COUNT = LOW_POWER ? 8 : 18;
    /* render at half resolution, stretched by CSS — invisible at 5% glow */
    function size() {
      W = Math.ceil(window.innerWidth / 2);
      H = Math.ceil(window.innerHeight / 2);
      cv.width = W; cv.height = H;
    }
    size(); window.addEventListener('resize', size);
    for (var i = 0; i < COUNT; i++) {
      parts.push({ x: ((i * 73) % 100) / 100, y: (i / COUNT), v: 0.0004 + (i % 5) * 0.00022, r: 0.5 + (i % 3) * 0.35, w: (i * 37) % 100 });
    }
    var last = 0;
    (function frame(t) {
      if (!S.open) { emberRAF = 0; return; }
      emberRAF = requestAnimationFrame(frame);
      if (t - last < 33 || document.hidden) return; /* ~30fps, naps when hidden */
      last = t;
      ctx.clearRect(0, 0, W, H);
      for (var i = 0; i < parts.length; i++) {
        var p = parts[i];
        p.y -= p.v * 2; if (p.y < -0.02) p.y = 1.02;
        var x = (p.x + Math.sin((t * 0.0003) + p.w) * 0.012) * W;
        var a = 0.10 + 0.10 * Math.sin(t * 0.002 + p.w);
        ctx.beginPath();
        ctx.arc(x, p.y * H, p.r, 0, 6.2832);
        ctx.fillStyle = 'rgba(197,48,44,' + a.toFixed(3) + ')';
        ctx.fill();
      }
    })(0);
  }

  function stage() { return shell.querySelector('.rite__stage'); }

  /* screen transition: a held breath — the outgoing screen loses focus
     and sinks, the incoming one resolves from blur to focus. No flashes,
     no drawn effects. Timings on the golden ratio (240ms out, 680ms in). */
  /* in-place swap for screens that REUSE their node (the verdict's
     offering <-> reading): without this, rite-out's 'both' fill pins the
     node at opacity 0 forever — the empty-black-screen bug */
  function veilSwap(node, render) {
    if (REDUCED) { render(); return; }
    node.classList.add('rite-out');
    setTimeout(function () {
      node.classList.remove('rite-out');
      render();
      node.classList.remove('rite-in');
      void node.offsetWidth;
      node.classList.add('rite-in');
    }, 380);
  }

  function crackFlash(cb) {
    if (REDUCED) { cb(); return; }
    var cur = stage().firstElementChild;
    if (!cur) { cb(); return; }
    cur.classList.add('rite-out');
    setTimeout(cb, 360); /* 300ms out + a short held black */
  }

  /* ---------------- open / close ---------------- */
  function openRite(opts) {
    opts = opts || {};
    buildShell();
    /* CATALOGO SCALDATO (owner 28-08-2026): la fetch di products.json
       partiva alla schermata che serviva per prima, cioe' DENTRO il rito,
       e li' si vedeva. Parte all'apertura: la promessa e' gia' risolta
       quando serve, e se la rete e' lenta il ritardo cade sul nulla
       invece che su un passo. loadCatalog e' idempotente (memoizza la
       promise), quindi le chiamate successive restano una sola richiesta. */
    try { loadCatalog(); } catch (e) {}
    S.open = true;
    S.surface = opts.surface || 'unknown';
    S.step = 0;
    S.a = { collection: 'any', theme: null, stone: 'any', mat: 'any', cat: 'any', tier: 0 };
    S.preset = { collection: false, cat: false };

    var col = (opts.collection || '').toLowerCase();
    var catMap = { rings: 'ring', pendants: 'cross', earrings: 'ear', necklaces: 'neck', bracelets: 'wrist' };
    if (catMap[col]) { S.a.cat = catMap[col]; S.preset.cat = true; }
    if (col === 'reminescenza' || col === 'reminiscenza') { S.a.collection = 'rem'; S.preset.collection = true; }
    if (col === 'palinsesto') { S.a.collection = 'pal'; S.preset.collection = true; }
    if (col === 'materia') { S.a.collection = 'mat'; S.preset.collection = true; }

    S.savedScroll = window.scrollY || window.pageYOffset || 0;
    document.body.classList.add('rite-lock');
    shell.classList.add('is-open');
    window.__bhRiteOpen = true;
    track('ritual_start', { entry_surface: S.surface, collection: col });
    loadCatalog().then(function () {
      if (!S.open) return;
      ['rem', 'pal', 'mat'].forEach(function (k) {
        var src = collectionImage(k);
        if (src) { var im = new Image(); im.src = imgUrl(src, 700); }
      });
    });
    preloadCards();
    startEmbers();
    renderStep(0);
  }

  function closeRite(abandoned) {
    if (!S.open) return;
    S.open = false;
    window.__bhRiteOpen = false;
    if (emberRAF) cancelAnimationFrame(emberRAF);
    if (fractureCleanup) { fractureCleanup(); fractureCleanup = null; }
    shell.classList.remove('is-open');
    document.body.classList.remove('rite-lock');
    window.scrollTo(0, S.savedScroll);
    if (abandoned && S.step < 7) track('ritual_abandon', { ritual_question: S.step });
  }

  /* ---------------- flow ---------------- */
  function nextOf(step) {
    var n = step + 1;
    if (n === 2 && S.preset.collection) n = 3;
    if (n === 6 && S.preset.cat) n = 7;
    return n;
  }
  function goto(step) { crackFlash(function () { S.step = step; renderStep(step); }); }
  function setScreen(node) {
    var st = stage();
    st.innerHTML = '';
    st.appendChild(node);
    st.scrollTop = 0;
    if (!REDUCED) node.classList.add('rite-in');
    var f = node.querySelector('[autofocus]');
    if (f) try { f.focus({ preventScroll: true }); } catch (e) {}
  }
  function ritePath() {
    var p = [1];
    if (!S.preset.collection) p.push(2);
    p.push(3, 4, 5);
    if (!S.preset.cat) p.push(6);
    p.push(7);
    return p;
  }
  function paintSteps(step) {
    var box = shell.querySelector('.rite__steps');
    if (!box) return;
    if (step === 0) { box.innerHTML = ''; return; }
    var path = ritePath();
    var idx = path.indexOf(step);
    if (idx < 0) { for (var z = 0; z < path.length; z++) if (path[z] <= step) idx = z; }
    var h = '';
    for (var i = 0; i < path.length; i++) {
      h += '<span class="rite__step-dot' + (i < idx ? ' is-done' : i === idx ? ' is-now' : '') + '"></span>';
    }
    box.innerHTML = h;
  }
  function persistRite() {
    try {
      if (S.step > 0 && S.step < 7) sessionStorage.setItem('bh_rite_state', JSON.stringify({ step: S.step, a: S.a, preset: S.preset }));
      else if (S.step >= 7) sessionStorage.removeItem('bh_rite_state');
    } catch (e) {}
  }

  function renderStep(step, soft) {
    if (wheelCleanup && step !== 4) { wheelCleanup(); wheelCleanup = null; }
    var facts = shell.querySelector('.rite__facts');
    if (facts) facts.hidden = (step === 0); /* the facts ride every screen after the threshold */
    if (fractureCleanup && step !== 0) { fractureCleanup(); fractureCleanup = null; }
    paintSteps(step);
    persistRite();
    switch (step) {
      case 0: return screenFracture(soft);
      case 1: return screenWorld();
      case 2: return screenCollections();
      case 3: return screenMeaning();
      case 4: return screenWheel();
      case 5: return screenMetal();
      case 6: return screenForm();
      case 7: return screenVerdict();
    }
  }

  /* ================================================================
     STEP 0 — THE THRESHOLD (owner: no intro film).
     Pure black; the manifesto resolves from blur; then the dark warms
     from true black into a deep umber glow — the room lights, the
     rite begins. CTAs present from the start.
  ================================================================ */
  function screenFracture(soft) {
    var lines = COPY.s0;
    var n = el('div', 'rite__s rite__s0');
    n.innerHTML =
      '<div class="rite__s0-body">' +
        ((REDUCED || soft) ? '' : '<video class="rite__heart" muted playsinline preload="auto" src="' + HEART_FILM + '" aria-hidden="true"></video>') +
        '<div class="rite__s0-lines">' + lines.map(function (l) { return '<p class="rite__line rite__line--veil">' + l + '</p>'; }).join('') + '</div>' +
        '<div class="rite__row rite__s0-ctas">' +
          '<button type="button" class="rite__btn" data-go="next">' + COPY.s0cta + '</button>' +
          (savedRite() ? '<button type="button" class="rite__ghost" data-go="resume">' + COPY.s0resume + '</button>' : '<button type="button" class="rite__ghost" data-go="skip">' + COPY.s0skip + '</button>') +
        '</div>' +
      '</div>';
    setScreen(n);
    n.querySelector('[data-go="next"]').addEventListener('click', function () { goto(1); });
    var skipBtn = n.querySelector('[data-go="skip"]');
    if (skipBtn) skipBtn.addEventListener('click', function () { track('rite_skip', { screen: 0 }); goto(S.preset.collection ? 3 : 2); });
    var resumeBtn = n.querySelector('[data-go="resume"]');
    if (resumeBtn) resumeBtn.addEventListener('click', function () {
      var sv = savedRite();
      if (!sv) { goto(1); return; }
      S.a = sv.a; S.preset = sv.preset;
      track('rite_resume', { step: sv.step });
      goto(sv.step);
    });

    /* failsafe: the CTAs must NEVER be invisible, whatever the CSS says */
    setTimeout(function () {
      var ct = n.querySelector('.rite__s0-ctas');
      if (ct) ct.style.setProperty('opacity', '1', 'important');
    }, 1400);

    if (REDUCED || soft) { n.classList.add('is-settled'); return; }
    /* the heart breaks once and HOLDS on its last frame as the emblem;
       the manifesto resolves while it cracks, the dark warms after */
    var v = n.querySelector('.rite__heart');
    var t1 = setTimeout(function () { n.classList.add('is-settled'); }, 1500);
    if (v) {
      v.addEventListener('canplay', function onCan() {
        v.removeEventListener('canplay', onCan);
        var p = v.play();
        if (p && p.catch) p.catch(function () { v.style.display = 'none'; });
        n.classList.add('is-heart');
      });
      v.addEventListener('error', function () { v.style.display = 'none'; });
    }
    fractureCleanup = function () { clearTimeout(t1); try { if (v) v.pause(); } catch (e) {} };
  }

  /* ================================================================
     RITUAL SELECTION (§4b) — every choice is a row, never a box.
     Hover: siblings recede, the row lights bone->white, a garnet
     crack underlines it, an ember kindles at its left.
     Click: the row "cracks" (micro-shake + garnet glow), then commits.
  ================================================================ */
  function ritualScreen(opts) {
    var n = el('div', 'rite__s rite__rs');
    var rows = opts.rows.map(function (r, i) {
      return '<button type="button" class="rite__rrow" data-k="' + r.k + '" role="radio" aria-checked="false" style="--i:' + i + '">' +
        '<span class="rite__rrow-ember" aria-hidden="true"></span>' +
        '<span class="rite__rrow-text">' + esc(r.label) + (r.line ? ' <em class="rite__rrow-line">— ' + r.line + '</em>' : '') + '</span>' +
        '<span class="rite__rrow-crack" aria-hidden="true"></span>' +
      '</button>';
    }).join('');
    n.innerHTML =
      '<h2 class="rite__h">' + opts.title + '</h2>' +
      (opts.hint ? '<p class="rite__hint">' + opts.hint + '</p>' : '') +
      '<div class="rite__rrows" role="radiogroup" aria-label="' + esc(opts.title) + '">' + rows + '</div>' +
      (opts.ghost ? '<button type="button" class="rite__ghost rite__center" data-k="' + opts.ghostK + '">' + opts.ghost + '</button>' : '');
    setScreen(n);
    var btns = n.querySelectorAll('[data-k]');
    var locked = false;
    for (var i = 0; i < btns.length; i++) {
      btns[i].addEventListener('click', function () {
        if (locked) return;
        locked = true;
        var k = this.getAttribute('data-k');
        var isRow = this.classList.contains('rite__rrow');
        if (isRow && !REDUCED) {
          this.classList.add('is-struck');
          this.setAttribute('aria-checked', 'true');
          var rowsAll = n.querySelectorAll('.rite__rrow');
          for (var j = 0; j < rowsAll.length; j++) if (rowsAll[j] !== this) rowsAll[j].classList.add('is-mute');
          setTimeout(function () { opts.onPick(k); }, 460);
        } else {
          opts.onPick(k);
        }
      });
    }
    return n;
  }

  /* ---------------- step 1: il mondo ---------------- */
  function screenWorld() {
    var n = el('div', 'rite__s rite__s1');
    n.innerHTML =
      '<div class="rite__s0-lines">' + COPY.s1.map(function (l) { return '<p class="rite__line rite__line--world">' + l + '</p>'; }).join('') + '</div>' +
      '<button type="button" class="rite__btn" autofocus>' + COPY.s1cta + '</button>';
    setScreen(n);
    n.querySelector('.rite__btn').addEventListener('click', function () { goto(nextOf(1)); });
  }

  /* ---------------- step 2: le collezioni ---------------- */
  function screenCollections() {
    var n = el('div', 'rite__s rite__s2');
    var cards = ['rem', 'pal', 'mat'].map(function (k, i) {
      var c = COPY.collections[k];
      return '<button type="button" class="rite__col" data-col="' + k + '" style="--i:' + i + '">' +
        '<span class="rite__col-img"><img alt="' + c.name + '" data-colimg="' + k + '" loading="lazy"></span>' +
        '<span class="rite__col-name">' + c.name + '</span>' +
        '<span class="rite__col-line">' + c.line + '</span>' +
        '<span class="rite__col-desc">' + c.desc + '</span>' +
      '</button>';
    }).join('');
    n.innerHTML = '<h2 class="rite__h">' + COPY.s2title + '</h2><p class="rite__hint">' + COPY.s2hint + '</p>' +
      '<div class="rite__cols">' + cards + '</div>' +
      '<button type="button" class="rite__ghost rite__center" data-col="any">' + COPY.s2decide + '</button>';
    setScreen(n);
    loadCatalog().then(function () {
      if (!S.open) return;
      var imgs = n.querySelectorAll('[data-colimg]');
      for (var i = 0; i < imgs.length; i++) {
        var src = collectionImage(imgs[i].getAttribute('data-colimg'));
        if (src) imgs[i].src = imgUrl(src, 700);
      }
    });
    var btns = n.querySelectorAll('[data-col]');
    for (var i = 0; i < btns.length; i++) {
      btns[i].addEventListener('click', function () {
        S.a.collection = this.getAttribute('data-col');
        track('ritual_answer', { ritual_question: 'collection', value: S.a.collection });
        goto(3);
      });
    }
  }

  /* ---------------- step 3: il significato (ritual rows) ---------------- */
  function screenMeaning() {
    var mNode = ritualScreen({
      title: COPY.s3title,
      rows: COPY.themes.map(function (t) {
        return { k: t.k, label: t.en };
      }),
      onPick: function (k) {
        S.a.theme = k;
        S.a.thoughtWord = null; S.a.stoneHint = null;
        track('ritual_answer', { ritual_question: 'theme', value: k });
        goto(4);
      }
    });

    /* il pensiero scritto: sta QUI, sullo schermo che gia' chiede il
       significato, cosi' non si tocca la macchina dei passi. Chi non scrive
       vede esattamente il rito di prima. */
    var box = el("div", "rite__thought");
    box.innerHTML =
      '<p class="rite__thought-ask">' + COPY.thought.ask + '</p>' +
      '<textarea class="rite__thought-in" rows="3" maxlength="400" placeholder="' + esc(COPY.thought.place) + '" aria-label="' + esc(COPY.thought.place) + '"></textarea>' +
      '<button type="button" class="rite__ghost rite__thought-go">' + COPY.thought.send + '</button>' +
      '<p class="rite__thought-msg" role="status" aria-live="polite"></p>';
    mNode.appendChild(box);
    var ta = box.querySelector(".rite__thought-in");
    var msg = box.querySelector(".rite__thought-msg");
    box.querySelector(".rite__thought-go").addEventListener("click", function () {
      var raw = (ta.value || "").trim();
      if (!raw) { ta.focus(); return; }
      var r = readThought(raw);
      if (!r) { msg.textContent = COPY.thought.none; ta.focus(); return; }
      S.a.theme = r.theme;
      S.a.thought = raw.slice(0, 400);
      S.a.thoughtWord = r.word;
      S.a.stoneHint = r.stone;
      track("ritual_answer", { ritual_question: "theme", value: r.theme, source: "thought" });
      track("rite_thought", { theme: r.theme, stone: r.stone || "none", chars: raw.length });
      goto(4);
    });
  }

  /* ================================================================
     STEP 4 — DRAW YOUR STONE (§7): the canonical interaction is the
     swipe DECK (touch / phones / tablets / any coarse-or-narrow device):
     one card is drawn to center, the peers peek and dim, and a draw/flip
     plays on commit. Hover-capable wide screens keep the refined fanned
     RING. The deck is the everywhere path; the ring is the desktop luxury.
  ================================================================ */
  function screenWheel() {
    if (wheelCleanup) { wheelCleanup(); wheelCleanup = null; }
    var n0 = el('div', 'rite__s');
    n0.innerHTML = '<div class="rite__forging"><span class="rite__loader"></span></div>';
    setScreen(n0);
    loadCatalog().then(function () {
      if (!S.open || S.step !== 4) return;
      /* the wheel offers only stones this surface can honor without a dead end:
         when a category is declared (pendants/necklaces/...), gate by the PLACE
         too (>=1 real piece) so the drawn stone never lands on a form the house
         doesn't make in it; concept entries still want a full trio. */
      var catSet = (S.a.cat && S.a.cat !== 'any');
      var stones = COPY.stones.filter(function (st) {
        return countCell(PRODUCTS, S.a.collection, st.k, S.a.cat) >= (catSet ? 1 : 3);
      });
      if (!stones.length) stones = COPY.stones.slice();
      var W = { 3: 'three', 4: 'four', 5: 'five', 6: 'six' };
      var hint = stones.length >= 6 ? COPY.s4hint : 'This house holds ' + (W[stones.length] || stones.length) + ' of the six. One is yours.';
      /* se ha scritto, il rito lo dice qui: le sue parole, non le nostre */
      if (S.a.thoughtWord) {
        var sName = null;
        for (var qi = 0; qi < COPY.stones.length; qi++) if (COPY.stones[qi].k === S.a.stoneHint) sName = COPY.stones[qi].name;
        hint = COPY.thought.read + ' <em class="rite__quote">' + esc(S.a.thoughtWord) + '</em>. ' +
               (sName ? COPY.thought.toward + ' ' + sName + '.' : '');
      }
      /* the swipe deck is canonical everywhere except hover-capable wide screens */
      var deck = window.matchMedia('(max-width: 768px), (hover: none), (pointer: coarse)').matches;
      if (deck) wheelCarousel(stones, hint); else wheelRing(stones, hint);
    });
  }

  function wheelRing(STONES, hint) {
    var n = el('div', 'rite__s rite__s4 rite__s4--wheel');
    var cards = STONES.map(function (st, i) {
      return '<button type="button" class="rite__wcard" data-stone="' + st.k + '" data-idx="' + i + '" role="radio" aria-checked="false" aria-label="' + st.num + ' ' + st.name + ' — ' + st.line + '">' +
        '<img src="' + imgUrl(st.art, 720) + '" alt="" width="480" height="720" draggable="false">' +
      '</button>';
    }).join('');
    n.innerHTML =
      '<div class="rite__wheelhead"><h2 class="rite__h">' + COPY.s4title + '</h2><p class="rite__hint">' + COPY.s4hint + '</p></div>' +
      '<div class="rite__wheel" role="radiogroup" aria-label="' + COPY.s4title + '">' +
        '<div class="rite__wheel-glow" aria-hidden="true"></div>' +
        cards +
        '<div class="rite__wfocus" hidden>' +
          '<span class="rite__wfocus-dot"></span>' +
          '<span class="rite__wfocus-name"></span>' +
          '<span class="rite__wfocus-sub"></span>' +
          '<span class="rite__wfocus-line"></span>' +
          '<button type="button" class="rite__btn rite__wfocus-take">' + COPY.s4take + '</button>' +
          '<button type="button" class="rite__ghost rite__wfocus-back">' + COPY.s4return + '</button>' +
        '</div>' +
      '</div>';
    setScreen(n);

    var wheel = n.querySelector('.rite__wheel');
    var cardEls = n.querySelectorAll('.rite__wcard');
    var focusEl = n.querySelector('.rite__wfocus');
    var chosen = -1;

    function layout() {
      var W = wheel.clientWidth, H = wheel.clientHeight;
      var i, c, deg, rad;
      for (i = 0; i < cardEls.length; i++) {
        c = cardEls[i];
        if (i === chosen) continue;
        deg = (360 / cardEls.length) * i - 90;
        rad = deg * Math.PI / 180;
        /* radius clamped so the top card clears the title above the wheel */
        var R = Math.min(W * 0.36, H * 0.33);
        c.style.setProperty('--tx', (W / 2 + R * Math.cos(rad)) + 'px');
        c.style.setProperty('--ty', (H * 0.56 + R * Math.sin(rad)) + 'px');
        c.style.setProperty('--rot', (deg + 90) + 'deg');
        c.style.setProperty('--sc', '1');
        c.style.zIndex = 2 + i;
      }
      if (chosen > -1) {
        c = cardEls[chosen];
        c.style.setProperty('--tx', (W / 2) + 'px');
        c.style.setProperty('--ty', (H * 0.42) + 'px');
        c.style.setProperty('--rot', '0deg');
        c.style.setProperty('--sc', '1.6');
        c.style.zIndex = 40;
      }
    }
    function choose(idx) {
      chosen = idx;
      var st = STONES[idx];
      wheel.classList.add('is-chosen');
      for (var i = 0; i < cardEls.length; i++) {
        cardEls[i].classList.toggle('is-dim', i !== idx);
        cardEls[i].setAttribute('aria-checked', i === idx ? 'true' : 'false');
      }
      focusEl.querySelector('.rite__wfocus-dot').style.background = st.dot || 'transparent';
      focusEl.querySelector('.rite__wfocus-dot').style.visibility = st.dot ? 'visible' : 'hidden';
      focusEl.querySelector('.rite__wfocus-name').textContent = st.num + ' · ' + st.name;
      focusEl.querySelector('.rite__wfocus-sub').textContent = st.sub;
      focusEl.querySelector('.rite__wfocus-line').textContent = st.line;
      focusEl.hidden = false;
      layout();
    }
    function unchoose() {
      chosen = -1;
      wheel.classList.remove('is-chosen');
      focusEl.hidden = true;
      for (var i = 0; i < cardEls.length; i++) { cardEls[i].classList.remove('is-dim'); cardEls[i].setAttribute('aria-checked', 'false'); }
      layout();
    }
    for (var ci = 0; ci < cardEls.length; ci++) {
      cardEls[ci].addEventListener('click', function () {
        var idx = parseInt(this.getAttribute('data-idx'), 10);
        if (chosen === idx) return;
        choose(idx);
      });
    }
    focusEl.querySelector('.rite__wfocus-back').addEventListener('click', unchoose);
    focusEl.querySelector('.rite__wfocus-take').addEventListener('click', commitStone);
    function commitStone() {
      if (chosen < 0) return;
      try { if (navigator.vibrate) navigator.vibrate(20); } catch (e) {}
      S.a.stone = STONES[chosen].k;
      track('ritual_answer', { ritual_question: 'stone', value: S.a.stone });
      goto(5);
    }
    var onResize = function () { layout(); };
    window.addEventListener('resize', onResize);
    wheelCleanup = function () { window.removeEventListener('resize', onResize); };
    requestAnimationFrame(layout);
  }

  function wheelCarousel(STONES, hint) {
    var n = el('div', 'rite__s rite__s4 rite__s4--carousel');
    /* each card is a button: tap a peeked card to draw it to center
       (tap-to-draw), or swipe. The centered card is the drawn one. */
    var slides = STONES.map(function (st, i) {
      return '<button type="button" class="rite__wslide" data-idx="' + i + '" aria-label="' + st.num + ' ' + st.name + ' — ' + st.line + '">' +
        '<img src="' + imgUrl(st.art, 720) + '" alt="" width="480" height="720" draggable="false">' +
      '</button>';
    }).join('');
    n.innerHTML =
      '<div class="rite__wheelhead"><h2 class="rite__h">' + COPY.s4title + '</h2><p class="rite__hint">' + (hint || COPY.s4hint) + '</p></div>' +
      '<div class="rite__wrail" role="group" aria-label="' + COPY.s4title + '">' + slides + '</div>' +
      '<div class="rite__wdots" aria-hidden="true">' + STONES.map(function () { return '<span class="rite__wdot"></span>'; }).join('') + '</div>' +
      '<div class="rite__winfo" aria-live="polite">' +
        '<span class="rite__wfocus-dot"></span>' +
        '<span class="rite__wfocus-name"></span>' +
        '<span class="rite__wfocus-sub"></span>' +
        '<span class="rite__wfocus-line"></span>' +
      '</div>' +
      '<button type="button" class="rite__btn rite__wtake">' + COPY.s4take + '</button>';
    setScreen(n);

    var rail = n.querySelector('.rite__wrail');
    var slideEls = n.querySelectorAll('.rite__wslide');
    var dots = n.querySelectorAll('.rite__wdot');
    var focused = -1, committing = false;
    function setInfo(i) {
      if (i === focused) return;
      focused = i;
      var st = STONES[i];
      n.querySelector('.rite__wfocus-dot').style.background = st.dot || 'transparent';
      n.querySelector('.rite__wfocus-dot').style.visibility = st.dot ? 'visible' : 'hidden';
      n.querySelector('.rite__wfocus-name').textContent = st.num + ' · ' + st.name;
      n.querySelector('.rite__wfocus-sub').textContent = st.sub;
      n.querySelector('.rite__wfocus-line').textContent = st.line;
      for (var d = 0; d < dots.length; d++) dots[d].classList.toggle('is-on', d === i);
      for (var s = 0; s < slideEls.length; s++) slideEls[s].classList.toggle('is-focused', s === i);
    }
    /* the focused card is the one nearest the rail's centre line */
    function nearest() {
      var rr = rail.getBoundingClientRect(), cx = rr.left + rr.width / 2, best = 0, bd = Infinity;
      for (var i = 0; i < slideEls.length; i++) {
        var r = slideEls[i].getBoundingClientRect();
        var d = Math.abs(r.left + r.width / 2 - cx);
        if (d < bd) { bd = d; best = i; }
      }
      return best;
    }
    function center(i) {
      try { slideEls[i].scrollIntoView({ inline: 'center', block: 'nearest', behavior: REDUCED ? 'auto' : 'smooth' }); }
      catch (e) { rail.scrollLeft = slideEls[i].offsetLeft - (rail.clientWidth - slideEls[i].clientWidth) / 2; }
    }
    var raf = 0;
    rail.addEventListener('scroll', function () {
      if (raf) return;
      raf = requestAnimationFrame(function () { raf = 0; setInfo(nearest()); });
    }, { passive: true });
    for (var ci = 0; ci < slideEls.length; ci++) {
      slideEls[ci].addEventListener('click', function () {
        var idx = parseInt(this.getAttribute('data-idx'), 10);
        if (idx !== focused) { center(idx); setInfo(idx); }
      });
    }
    setInfo(0);
    n.querySelector('.rite__wtake').addEventListener('click', function () {
      if (focused < 0 || committing) return;
      committing = true;
      try { if (navigator.vibrate) navigator.vibrate(20); } catch (e) {}
      S.a.stone = STONES[focused].k;
      track('ritual_answer', { ritual_question: 'stone', value: S.a.stone });
      if (REDUCED) { goto(5); return; }
      slideEls[focused].classList.add('is-drawn');   /* one-shot draw/flip on the chosen card */
      setTimeout(function () { goto(5); }, 380);
    });
  }

  /* ---------------- step 5: il metallo (ritual rows, §4b) ---------------- */
  function screenMetal() {
    var n0 = el('div', 'rite__s');
    n0.innerHTML = '<div class="rite__forging"><span class="rite__loader"></span></div>';
    setScreen(n0);
    loadCatalog().then(function () {
      if (!S.open || S.step !== 5) return;
      /* offer only metals this (collection, stone[, place]) cell can honor */
      var metals = COPY.metals.filter(function (m) {
        return countCellM(PRODUCTS, S.a.collection, S.a.stone, m.k, S.a.cat) >= 1;
      });
      if (metals.length <= 1) {
        S.a.mat = metals.length ? metals[0].k : 'any';
        track('ritual_answer', { ritual_question: 'metal', value: S.a.mat + ' (house)' });
        S.step = nextOf(5);
        renderStep(S.step);
        return;
      }
      ritualScreen({
        title: COPY.s45title,
        rows: metals.map(function (m) { return { k: m.k, label: m.label, line: m.line }; }),
        ghost: COPY.s45decide,
        ghostK: 'any',
        onPick: function (k) {
          S.a.mat = k;
          track('ritual_answer', { ritual_question: 'metal', value: k });
          goto(nextOf(5));
        }
      });
    });
  }

  /* ---------------- step 6: la forma (ritual rows, real forms only) ---------------- */
  function screenForm() {
    var n = el('div', 'rite__s rite__rs');
    n.innerHTML = '<h2 class="rite__h">' + COPY.s5title + '</h2><div class="rite__rrows" role="radiogroup"></div>' +
      '<button type="button" class="rite__ghost rite__center">' + COPY.s5decide + '</button>';
    setScreen(n);
    loadCatalog().then(function () {
      if (!S.open || S.step !== 6) return;
      var forms = poolForms(S.a.collection);
      if (forms.length <= 1) {
        /* one real form: the house decides, no fake choice */
        S.a.cat = forms.length ? forms[0] : 'any';
        track('ritual_answer', { ritual_question: 'form', value: S.a.cat + ' (house)' });
        S.step = 7;
        renderStep(7);
        return;
      }
      var wrap = n.querySelector('.rite__rrows');
      wrap.innerHTML = forms.map(function (f, i) {
        return '<button type="button" class="rite__rrow" data-k="' + f + '" role="radio" aria-checked="false" style="--i:' + i + '">' +
          '<span class="rite__rrow-ember" aria-hidden="true"></span>' +
          '<span class="rite__rrow-text">' + COPY.forms[f] + ' <em class="rite__rrow-line">— ' + COPY.formLines[f] + '</em></span>' +
          '<span class="rite__rrow-crack" aria-hidden="true"></span>' +
        '</button>';
      }).join('');
      var btns = wrap.querySelectorAll('.rite__rrow');
      var locked = false;
      var pick = function (k) {
        S.a.cat = k;
        track('ritual_answer', { ritual_question: 'form', value: k });
        goto(7);
      };
      for (var i = 0; i < btns.length; i++) {
        btns[i].addEventListener('click', function () {
          if (locked) return; locked = true;
          var k = this.getAttribute('data-k');
          if (!REDUCED) {
            this.classList.add('is-struck');
            for (var j = 0; j < btns.length; j++) if (btns[j] !== this) btns[j].classList.add('is-mute');
            setTimeout(function () { pick(k); }, 460);
          } else { pick(k); }
        });
      }
      n.querySelector('.rite__ghost').addEventListener('click', function () { pick('any'); });
    });
  }

  /* ================================================================
     STEP 7 — THE VERDICT: the offering, then the reading.
     Three pieces stand as equals. Choosing one starts its reading —
     line by line, composed from the answers given (theme, drawn
     stone, metal, form). All three can be read. One CTA -> real PDP.
     Redoing the rite never repeats pieces already shown (session
     memory), until the cell is exhausted and the deck reshuffles.
  ================================================================ */
  var DRAWN = [];
  var verdictR = null;

  function stoneCard(k) { for (var i = 0; i < COPY.stones.length; i++) if (COPY.stones[i].k === k) return COPY.stones[i]; return null; }

  /* THE SEAL — the broken heart of the house reads the answers.
     Plays once per session, between the last answer and the curtain:
     at ~2.2s the heart's crack completes and the curtain's garnet seam
     CONTINUES it (match cut). It also masks engine compute + trio
     preload, so the verdict opens already loaded. Redo skips it. */
  var HEART_FILM = 'https://cdn.shopify.com/videos/c/o/v/639dd552ae4a4eedaeccf02387037b01.mp4';

  function screenVerdict() {
    var n = el('div', 'rite__s rite__s7');
    n.innerHTML = '<div class="rite__forging"><span class="rite__loader"></span></div>';
    setScreen(n);
    loadCatalog().then(function () {
      if (!S.open || S.step !== 7) return;
      var r = pickRelics(PRODUCTS, S.a, DRAWN);
      if (!r.top) { closeRite(false); return; }
      var pieces = [r.top].concat(r.alts);
      var ids = pieces.map(function (p) { return p.id; });
      var allSeen = ids.every(function (id) { return DRAWN.indexOf(id) > -1; });
      if (allSeen) DRAWN = []; /* the cell is exhausted: the deck reshuffles */
      for (var i = 0; i < ids.length; i++) if (DRAWN.indexOf(ids[i]) === -1) DRAWN.push(ids[i]);
      verdictR = { pieces: pieces, bridge: r.bridge };
      for (var pi = 0; pi < pieces.length; pi++) { if (pieces[pi].img) { var pim = new Image(); pim.src = imgUrl(pieces[pi].img, pi === 0 ? 1100 : 700); } }
      track('ritual_complete', { ritual_archetype: S.a.stone, theme: S.a.theme });
      track('rite_verdict', { top: r.top.id, alts: r.alts.map(function (p) { return p.id; }).join(',') });
      renderOffering(n, true);
    });
  }

  function vHead(p) {
    var col = COPY.collections[p.collection];
    return '<div class="rite__v-head">' +
      '<span class="rite__v-title">' + COPY.verdict.head + '</span>' +
      '<span class="rite__v-chip">' + col.name + ' — ' + col.line + '</span>' +
    '</div>';
  }
  function vFoot() {
    return '<div class="rite__v-foot">' +
      '<button type="button" class="rite__ghost rite__v-redo">' + COPY.verdict.redo + '</button>' +
      '<a class="rite__ghost" href="' + CONTACT_URL + '">' + COPY.verdict.custode + '</a>' +
    '</div>' +
    '<p class="rite__v-sig">' + COPY.verdict.foot + '</p>';
  }
  function bindFoot(n) {
    n.querySelector('.rite__v-redo').addEventListener('click', function () {
      S.a = { collection: 'any', theme: null, stone: 'any', mat: 'any', cat: 'any', tier: 0 };
      S.preset = { collection: false, cat: false };
      track('rite_redo', {});
      goto(2);
    });
  }

  /* the offering: three equals, the visitor chooses */
  function renderOffering(n, withCurtain) {
    var pieces = verdictR.pieces;
    n.classList.add('rite__s7--reveal');
    n.innerHTML =
      (withCurtain ? '<div class="rite__curtain" aria-hidden="true"><span class="rite__curtain-l"></span><span class="rite__curtain-seam"></span><span class="rite__curtain-r"></span></div>' : '') +
      '<div class="rite__verdict">' +
        vHead(pieces[0]) +
        '<p class="rite__v-three">' + ({ 3: COPY.verdict.three, 2: COPY.verdict.two, 1: COPY.verdict.one }[pieces.length] || COPY.verdict.three) + '</p>' +
        (S.a.thoughtWord ? '<p class="rite__v-quote">' + COPY.thought.read + ' <em class="rite__quote">' + esc(S.a.thoughtWord) + '</em>.</p>' : '') +
        '<p class="rite__v-maison">' + COPY.verdict.maison + '</p>' +
        '<p class="rite__hint">' + (pieces.length === 1 ? COPY.verdict.oneVein : COPY.verdict.choose) + '</p>' +
        '<p class="rite__v-free">' + COPY.verdict.free + '</p>' +
        '<div class="rite__v-tri" style="grid-template-columns:repeat(' + pieces.length + ', 1fr);max-width:' + (pieces.length === 3 ? 960 : pieces.length === 2 ? 660 : 360) + 'px">' + pieces.map(function (p, i) {
          return '<button type="button" class="rite__v-piece" data-i="' + i + '" style="--i:' + i + '">' +
            '<span class="rite__v-pimg">' + (p.img ? '<img src="' + imgUrl(p.img, 700) + '" alt="' + esc(p.name) + '" loading="lazy" width="700" height="700">' : '') + '</span>' +
            '<span class="rite__v-pform">' + (COPY.forms[p.cat] || '') + '</span>' +
            '<span class="rite__v-pname">' + esc(p.name) + '</span>' +
            '<span class="rite__v-pline">' + p.line + '</span>' +
            '<span class="rite__v-pprice">' + (p.from ? COPY.verdict.from : '') + money(p.price) + '</span>' +
          '</button>';
        }).join('') + '</div>' +
        vFoot() +
      '</div>';
    if (withCurtain && !REDUCED) {
      requestAnimationFrame(function () { var c = n.querySelector('.rite__curtain'); if (c) c.classList.add('is-opening'); });
      setTimeout(function () { var c = n.querySelector('.rite__curtain'); if (c) c.remove(); }, 1400);
    } else if (withCurtain) {
      var c = n.querySelector('.rite__curtain'); if (c) c.remove();
    }
    var btns = n.querySelectorAll('.rite__v-piece');
    for (var i = 0; i < btns.length; i++) {
      btns[i].addEventListener('click', function () {
        var idx = parseInt(this.getAttribute('data-i'), 10);
        track('select_item', { handle: verdictR.pieces[idx].id, position: idx });
        veilSwap(n, function () { renderReading(n, idx); });
      });
    }
    bindFoot(n);
  }

  /* the reading: composed from the answers actually given */
  function buildReading(p, idx) {
    var L = [];
    L.push(COPY.verdict.ranks[Math.min(idx, 2)]);
    if (S.a.theme && COPY.themeOpen[S.a.theme]) L.push(COPY.themeOpen[S.a.theme]);
    var drew = (S.a.stone && S.a.stone !== 'any') ? stoneCard(S.a.stone) : null;
    var carries = stoneCard(p.stone);
    if (drew) {
      if (p.stone === S.a.stone) {
        L.push(S.a.stone === 'blank'
          ? COPY.read.drewSameNihil
          : COPY.read.drewSame.replace('{name}', drew.name).replace('{sub}', drew.sub));
      } else if (p.stone === 'blank') {
        L.push(COPY.read.drewAbsence.replace('{name}', drew.name));
      } else if (carries) {
        L.push(COPY.read.drewBridge.replace('{name}', drew.name).replace('{cname}', carries.name).replace('{csub}', carries.sub));
      }
    }
    if (S.a.mat !== 'any' && S.a.mat === p.mat) {
      L.push(p.mat === 'silver' ? COPY.read.matSilverAsked : COPY.read.matGoldAsked);
    } else {
      L.push(COPY.matLine[p.mat]);
    }
    if (COPY.formLines[p.cat]) L.push(COPY.formLines[p.cat]);
    if (idx === 0 && verdictR.bridge) L.push(COPY.bridge);
    return L;
  }

  function renderReading(n, idx) {
    var p = verdictR.pieces[idx];
    var lines = buildReading(p, idx);
    var others = [];
    for (var oi = 0; oi < verdictR.pieces.length; oi++) if (oi !== idx) others.push(oi);
    n.innerHTML =
      '<div class="rite__verdict">' +
        vHead(p) +
        '<div class="rite__v-main">' +
          '<a class="rite__v-media" data-handoff href="' + reclaimUrl(p) + '" aria-label="' + esc(p.name) + '">' + (p.img ? '<img src="' + imgUrl(p.img, 1100) + '" alt="' + esc(p.name) + '" width="1100" height="1100">' : '') + '</a>' +
          '<div class="rite__v-info">' +
            '<h2 class="rite__v-name"><a class="rite__v-namelink" data-handoff href="' + reclaimUrl(p) + '">' + esc(p.name) + '</a></h2>' +
            '<p class="rite__v-line">' + p.line + '</p>' +
            '<p class="rite__v-price">' + (p.from ? COPY.verdict.from : '') + money(p.price) + '</p>' +
            '<div class="rite__v-sense rite__v-sense--reading">' + lines.map(function (s, i) { return '<p style="--i:' + i + '">' + s + '</p>'; }).join('') + '</div>' +
            '<p class="rite__v-why" style="--i:' + lines.length + '">' + p.why + '</p>' +
            '<p class="rite__v-facts" style="--i:' + (lines.length + 1) + '">' + COPY.verdict.facts + '</p>' +
            '<a class="rite__btn rite__btn--solid rite__v-see" data-handoff style="--i:' + Math.min(lines.length + 2, 6) + '" href="' + reclaimUrl(p) + '">' + COPY.verdict.see + '<span class=\"rite__arr\">&rarr;</span></a>' +
            '<div class="rite__v-keep" style="--i:' + Math.min(lines.length + 3, 7) + '">' +
              '<button type="button" class="rite__ghost rite__v-keepbtn">' + COPY.keep.cta + '</button>' +
              '<div class="rite__v-keeprow" hidden>' +
                '<input type="email" placeholder="' + esc(COPY.keep.ph) + '" autocomplete="email">' +
                '<button type="button" class="rite__v-keepsend">' + COPY.keep.send + '</button>' +
              '</div>' +
            '</div>' +
            '<div class="rite__v-actions"><button type="button" class="rite__ghost rite__v-sharebtn">' + COPY.result.share + '</button><button type="button" class="rite__ghost rite__v-storybtn">' + COPY.result.story + '</button></div>' +
          '</div>' +
        '</div>' +
        '<div class="rite__v-others"' + (others.length ? '' : ' hidden') + '>' +
          '<button type="button" class="rite__ghost rite__v-back">' + (verdictR.pieces.length === 3 ? COPY.verdict.allThree : COPY.verdict.allOf) + '</button>' +
          '<p class="rite__v-also">' + (others.length === 1 ? COPY.verdict.otherOne : COPY.verdict.others) + '</p>' +
          '<div class="rite__v-othergrid">' + others.map(function (o) {
            var op = verdictR.pieces[o];
            return '<button type="button" class="rite__v-other" data-i="' + o + '">' +
              '<span class="rite__v-oimg">' + (op.img ? '<img src="' + imgUrl(op.img, 400) + '" alt="' + esc(op.name) + '" loading="lazy" width="400" height="400">' : '') + '</span>' +
              '<span class="rite__v-oname">' + esc(op.name) + '</span>' +
            '</button>';
          }).join('') + '</div>' +
        '</div>' +
        vFoot() +
      '</div>';
    stage().scrollTop = 0;
    /* keep your reading: the rite's lead — qualified by every answer */
    var keep = n.querySelector('.rite__v-keep');
    if (keep) {
      var keepBtn = keep.querySelector('.rite__v-keepbtn');
      var keepRow = keep.querySelector('.rite__v-keeprow');
      keepBtn.addEventListener('click', function () {
        keepBtn.hidden = true;
        keepRow.hidden = false;
        try { keepRow.querySelector('input').focus(); } catch (e) {}
      });
      keep.querySelector('.rite__v-keepsend').addEventListener('click', function () {
        var inp = keepRow.querySelector('input');
        var em = (inp.value || '').trim();
        if (!em || em.indexOf('@') < 1) { inp.focus(); return; }
        var btn = this; btn.disabled = true;
        fetch('https://a.klaviyo.com/client/subscriptions/?company_id=SYAmQc', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', revision: '2024-10-15' },
          body: JSON.stringify({
            data: {
              type: 'subscription',
              attributes: {
                custom_source: 'The Rite - reading',
                profile: { data: { type: 'profile', attributes: { email: em, properties: {
                  rite_stone: S.a.stone || '',
                  rite_theme: S.a.theme || '',
                  rite_metal: p.mat || '',
                  rite_collection: p.collection || '',
                  rite_piece: p.id || ''
                } } } }
              },
              relationships: { list: { data: { type: 'list', id: 'SC4ki7' } } }
            }
          })
        }).then(function () {
          keep.innerHTML = '<p class="rite__v-keepdone">' + COPY.keep.done + '</p>';
          track('rite_email_saved', { piece: p.id });
        }).catch(function () { btn.disabled = false; });
      });
    }

    bindShare(n);
    bindStory(n, p);

    /* photo, name and CTA all hand off to the real product page */
    var hand = n.querySelectorAll('[data-handoff]');
    for (var hi = 0; hi < hand.length; hi++) {
      hand[hi].addEventListener('click', function () {
        try { sessionStorage.setItem('bh_rite_done', '1'); } catch (e) {}
        track('rite_pdp_handoff', { handle: p.id, position: idx });
      });
    }
    n.querySelector('.rite__v-back').addEventListener('click', function () {
      veilSwap(n, function () { renderOffering(n, false); stage().scrollTop = 0; });
    });
    var oth = n.querySelectorAll('.rite__v-other');
    for (var i = 0; i < oth.length; i++) {
      oth[i].addEventListener('click', function () {
        var o2 = parseInt(this.getAttribute('data-i'), 10);
        track('select_item', { handle: verdictR.pieces[o2].id, position: o2 });
        veilSwap(n, function () { renderReading(n, o2); });
      });
    }
    bindFoot(n);
  }

  /* ---------------- floating card visibility (collection pages) ---------------- */
  (function initFloatingCard() {
    var floatBtn = document.querySelector('.bhr-float');
    if (!floatBtn) return;
    var toolbarEndPos = 0;
    var toolbar = document.querySelector('.bh-toolbar');
    if (toolbar) toolbarEndPos = toolbar.offsetHeight + toolbar.offsetTop;
    var lastScrollY = window.scrollY;
    var hideTimeout;
    function updateFloatVisibility() {
      var currentScrollY = window.scrollY;
      var shouldShow = currentScrollY > toolbarEndPos + 200;
      if (shouldShow && !floatBtn.classList.contains('is-active')) {
        floatBtn.classList.add('is-active');
      } else if (!shouldShow && floatBtn.classList.contains('is-active')) {
        floatBtn.classList.remove('is-active');
      }
      lastScrollY = currentScrollY;
    }
    window.addEventListener('scroll', updateFloatVisibility, { passive: true });
    updateFloatVisibility();
  })();

  /* ---------------- entry wiring ---------------- */
  document.addEventListener('click', function (e) {
    var t = e.target.closest ? e.target.closest('.js-bhr-open') : null;
    if (!t) return;
    e.preventDefault();
    openRite({
      surface: t.getAttribute('data-surface') || 'band',
      collection: t.getAttribute('data-collection') || ''
    });
  });

  try {
    if (sessionStorage.getItem('bh_rite_done') === '1') {
      var labels = document.querySelectorAll('[data-bhr-cta-label]');
      for (var li = 0; li < labels.length; li++) labels[li].textContent = COPY.verdict.reopen;
    }
  } catch (e) {}

  /* ----------------------------------------------------------------
     COLLECTION ENTRY (variant D, 60-sim winner): the strip wakes once
     when it enters the viewport; the floating card rises at mid-right
     only after ~60% of the grid is scrolled — a knowing nudge at
     decision fatigue, never a chat widget. The x is a pact: dismissed
     means gone for the whole session, across collections.
  ---------------------------------------------------------------- */
  (function entrySurfaces() {
    var strip = document.querySelector('.bhr-strip');
    if (strip && 'IntersectionObserver' in window && !REDUCED) {
      var sio = new IntersectionObserver(function (es) {
        for (var i = 0; i < es.length; i++) {
          if (es[i].isIntersecting) { strip.classList.add('is-alive'); sio.disconnect(); break; }
        }
      }, { threshold: 0.9 });
      sio.observe(strip);
    }
    var fab = document.querySelector('.bhr-fab');
    if (!fab) return;
    var dismissed = false, peeked = false;
    try {
      dismissed = sessionStorage.getItem('bh_rite_fab_x') === '1';
      peeked = sessionStorage.getItem('bh_rite_fab_peek') === '1';
    } catch (e) {}
    if (dismissed) return;
    var x = fab.querySelector('[data-bhr-fab-x]');
    if (x) {
      var dismiss = function (ev) {
        ev.stopPropagation(); ev.preventDefault();
        fab.hidden = true;
        try { sessionStorage.setItem('bh_rite_fab_x', '1'); } catch (e) {}
        track('rite_fab_dismiss', {});
      };
      x.addEventListener('click', dismiss);
      x.addEventListener('keydown', function (ev) { if (ev.key === 'Enter' || ev.key === ' ') dismiss(ev); });
    }
    var grid = document.querySelector('.bh-collection__grid');
    var shown = false, ticking = false;
    function maybeShow() {
      if (shown || window.__bhRiteOpen) return;
      var trigger;
      if (grid) {
        var top = grid.getBoundingClientRect().top + window.scrollY;
        trigger = top + grid.offsetHeight * 0.6 - window.innerHeight;
      } else {
        trigger = window.innerHeight * 1.2;
      }
      if (window.scrollY > trigger) {
        shown = true;
        fab.hidden = false;
        requestAnimationFrame(function () { fab.classList.add('is-in'); });
        track('rite_fab_shown', {});
        if (!peeked && !REDUCED) {
          setTimeout(function () { fab.classList.add('is-peeking'); }, 900);
          setTimeout(function () { fab.classList.remove('is-peeking'); }, 3900);
          try { sessionStorage.setItem('bh_rite_fab_peek', '1'); } catch (e) {}
        }
        window.removeEventListener('scroll', onScroll);
      }
    }
    function onScroll() {
      if (ticking) return; ticking = true;
      requestAnimationFrame(function () { ticking = false; maybeShow(); });
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    maybeShow();
  })();

  /* ------------------------------------------------------------------
     MOTORE CONDIVISO (28-08-2026). LA VEGLIA (assets/bh-veglia.js) e una
     seconda interfaccia sullo STESSO motore: qui non cambia una riga di
     logica, si apre solo una porta. Senza questo blocco le funzioni pure
     restano chiuse nella IIFE e la sola alternativa sarebbe duplicarle,
     cioe avere due motori che divergono al primo fix.
     Le funzioni che leggono lo stato globale S sono esposte come wrapper
     che S lo impostano prima di chiamare (shareStory, reclaimUrl).
  ------------------------------------------------------------------ */
  window.BHRiteEngine = {
    catalog: function () { return loadCatalog(); },
    pickRelics: pickRelics,
    readThought: readThought,
    hashStr: hashStr,
    countCell: countCell,
    encodeRite: encodeRite,
    decodeRite: decodeRite,
    THEME_STONE: THEME_STONE,
    FAMILY_META: FAMILY_META,
    COPY: COPY,
    root: function () { return ROOT; },
    productUrl: function (p) { return productUrl(p); },
    reclaimUrl: function (a, p) { S.a = a; return reclaimUrl(p); },
    shareStory: function (a, p, btn, url) { S.a = a; return shareStory(p, btn, url); }
  };

  /* the shared result page (/pages/rite) renders deterministically from the token */
  initResultPage();

  document.addEventListener('shopify:section:unload', function () { if (S.open) closeRite(false); });
})();
